import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useTranslation, Trans } from 'react-i18next';
import { styled, Button as Button$1, ThemeProvider, CssBaseline, Icon, Typography, Avatar as Avatar$1, Stack, IconButton as IconButton$1, FilledInput, Box, LinearProgress, useMediaQuery, FormControlLabel, Checkbox as Checkbox$1, TextField, Drawer as Drawer$1, MenuList, MenuItem, ListItemIcon, ListItemText, ListItem, ListItemAvatar, Dialog as Dialog$1, Link, alpha, FormHelperText, InputLabel, FormControl, InputAdornment, Select, NativeSelect, Tooltip, CircularProgress, Modal as Modal$1, ClickAwayListener, Radio as Radio$1, Backdrop } from '@mui/material';
import { Share, Follow, CastCredit, IncrementTriangle, Close, Calendar, WatchTriangle, RecastR, Warning, Cog, RecastText, Profile, ThreeDotsVertical, Ticket as Ticket$1, MuteIcon } from '@content-technology-partners-ltd/shared-icon';
import '@fontsource-variable/outfit';
import { createTheme, styled as styled$1, useTheme } from '@mui/material/styles';
import Button$2 from '@mui/material/Button';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import SvgIcon from '@mui/material/SvgIcon';
import AnimatedNumbers from 'react-animated-numbers';
import { useReducer, useState, useEffect, forwardRef, useRef, useMemo, createRef, Suspense, lazy, useCallback, useContext, createContext } from 'react';
import { castsToCurrencyString, getCastsBonus, percentageFrom, extractPaddingAsNumber, stringToColor, stringToOneChar, timeBetween, getDynamicColorFromBg, trim } from '@content-technology-partners-ltd/shared-util';
import { useField, Form, Formik, useFormikContext } from 'formik';
import { useTextFit, useDebounced, useResizeObserver } from '@content-technology-partners-ltd/hooks';
import { PlayArrow, Delete, Flag, Block, MoreVert, HighlightOff, VisibilityOff, Visibility, Info, Facebook } from '@mui/icons-material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { camelCase, debounce } from 'lodash';
import Lottie from 'lottie-web';
import Tooltip$1 from '@mui/material/Tooltip';
import Stack$1 from '@mui/material/Stack';
import Box$1 from '@mui/material/Box';
import { Google, ChannelPassEmptyInset } from '@content-technology-partners-ltd/shared-image';
import throttle from 'lodash/throttle';
import ArrowBack from '@mui/icons-material/ArrowBackIos';
import ArrowForward from '@mui/icons-material/ArrowForwardIos';

function _define_property$t(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$r(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$t(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$n(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$n(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$n(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var StyledButton$5 = styled(Button$1)(function(param) {
    param.theme;
    return {
        weight: 600
    };
});
function Button(props) {
    var children = props.children;
    return /*#__PURE__*/ jsx(StyledButton$5, _object_spread_props$n(_object_spread$r({}, props), {
        children: children
    }));
}

function _define_property$s(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _palette_common, _palette_grey, _palette_grey1, _palette_grey2, _palette_grey3, _palette_grey4, _palette_grey5, _palette_common1, _palette_common2, _palette_common3, _palette_grey6, _palette_text, _palette_common4, _palette_grey7, _palette_grey8;
var breakpoints$1 = {
    values: {
        xxs: 0,
        xs: 477,
        sm: 766,
        md: 990,
        lg: 1536,
        xl: 1920
    }
};
var palette = {
    background: {
        default: "#FAFAFA",
        paper: "#FFFFFF"
    },
    primary: {
        main: "#00E8D0",
        dark: "#00C8B3",
        light: "#95F1E3",
        contrastText: "#1E211D"
    },
    secondary: {
        main: "#1E211D",
        dark: "#000000",
        light: "#5D615C"
    },
    text: {
        primary: "rgba(30, 33, 29, 0.87)",
        secondary: "rgba(30, 33, 29, 0.5)",
        disabled: "rgba(30, 33, 29, 0.26)"
    },
    error: {
        main: "#E8000C",
        dark: "#BD0000",
        light: "#F33932"
    },
    warning: {
        main: "#FF8300",
        dark: "#DA7000",
        light: "#FFA343"
    },
    info: {
        main: "#12BDF8",
        dark: "#009CD2",
        light: "#47D0FF"
    },
    success: {
        main: "#00DA40",
        dark: "#00B42F",
        light: "#7BE780"
    },
    action: {
        active: "rgba(30, 33, 29, 0.54)",
        disabled: "rgba(30, 33, 29, 0.26)",
        disabledBackground: "rgba(30, 33, 29, 0.12)",
        focus: "rgba(30, 33, 29, 0.12)",
        hover: "rgba(0, 232, 208, 0.2)",
        selected: "#1E211D"
    },
    divider: "rgba(30, 33, 29, 0.12)",
    common: {
        black: "#1E211D",
        white: "#FFFFFF"
    },
    grey: {
        50: "#f3f3f3",
        100: "#F0F0F0",
        200: "#D8D8D8",
        300: "#CCCCCC",
        400: "#BDBDBD",
        500: "#797979",
        600: "#757575",
        700: "#444444",
        800: "",
        900: ""
    },
    containerBorder: {
        main: "#D5D5D5"
    },
    earn: {
        main: "#3233FF",
        dark: "#1E1FD6",
        light: "#5959FF",
        contrastText: "#FFF"
    }
};
var typography$1 = {
    fontFamily: [
        "Outfit Variable, sans-serif"
    ].join(","),
    h1: {
        fontSize: "36px",
        lineHeight: "44px",
        fontWeight: 600
    },
    h2: {
        fontSize: "32px",
        lineHeight: "36px",
        fontWeight: 600
    },
    h3: {
        fontSize: "28px",
        lineHeight: "32px",
        fontWeight: 600
    },
    h4: {
        fontSize: "24px",
        lineHeight: "28px",
        fontWeight: 600
    },
    h5: {
        fontSize: "21px",
        lineHeight: "24px",
        fontWeight: 600
    },
    h6: {
        fontSize: "18px",
        lineHeight: "24px",
        fontWeight: 600
    },
    subtitle1: {
        fontSize: "16px",
        lineHeight: "28px",
        fontWeight: 400
    },
    subtitle2: {
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: 500
    },
    body1: {
        fontSize: "16px",
        lineHeight: "21px",
        fontWeight: 400
    },
    body2: {
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: 400
    },
    caption: {
        fontSize: "12px",
        lineHeight: "26px",
        fontWeight: 400
    },
    overline: {
        fontSize: "12px",
        lineHeight: "32px",
        transform: "uppercase",
        fontWeight: 400
    },
    button: {
        fontSize: "14px",
        lineHeight: "21px",
        fontWeight: 400,
        textTransform: "none"
    }
};
var components$1 = {
    MuiTableCell: {
        variants: [
            {
                props: {
                    variant: "withoutBorder"
                },
                style: {
                    borderBottom: "none"
                }
            }
        ],
        styleOverrides: {
            root: function() {
                return accountTheme.unstable_sx(_define_property$s({}, accountTheme.breakpoints.down("sm"), {
                    verticalAlign: "top",
                    padding: "12px"
                }));
            }
        }
    },
    MuiButton: {
        styleOverrides: {
            root: {
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
                boxShadow: "none",
                borderRadius: "3px",
                "&:hover": {
                    boxShadow: "none"
                }
            }
        },
        variants: [
            {
                props: {
                    variant: "socialLogin"
                },
                style: {
                    borderRadius: "4px",
                    color: (_palette_common = palette.common) === null || _palette_common === void 0 ? void 0 : _palette_common.black,
                    border: "1px solid ".concat((_palette_grey = palette.grey) === null || _palette_grey === void 0 ? void 0 : _palette_grey[400]),
                    cursor: "pointer",
                    padding: "8px 14px",
                    background: "none",
                    fontSize: "12px",
                    fontWeight: 400,
                    "&:hover": {
                        background: (_palette_grey1 = palette.grey) === null || _palette_grey1 === void 0 ? void 0 : _palette_grey1[100]
                    }
                }
            },
            {
                props: {
                    variant: "modal"
                },
                style: {
                    borderRadius: "18px",
                    color: (_palette_grey2 = palette.grey) === null || _palette_grey2 === void 0 ? void 0 : _palette_grey2[500],
                    border: "1px solid ".concat((_palette_grey3 = palette.grey) === null || _palette_grey3 === void 0 ? void 0 : _palette_grey3[700]),
                    cursor: "pointer",
                    padding: "8px 26px",
                    background: "none",
                    fontSize: "11px",
                    fontWeight: 300,
                    "&:hover": {
                        background: (_palette_grey4 = palette.grey) === null || _palette_grey4 === void 0 ? void 0 : _palette_grey4[100]
                    },
                    ".light &": {
                        borderColor: (_palette_grey5 = palette.grey) === null || _palette_grey5 === void 0 ? void 0 : _palette_grey5[400]
                    }
                }
            }
        ]
    },
    MuiLink: {
        styleOverrides: {
            root: {
                color: (_palette_common1 = palette.common) === null || _palette_common1 === void 0 ? void 0 : _palette_common1.black,
                textDecorationColor: (_palette_common2 = palette.common) === null || _palette_common2 === void 0 ? void 0 : _palette_common2.black,
                "&:hover": {
                    color: palette.primary
                },
                "&:visited": {
                    color: (_palette_common3 = palette.common) === null || _palette_common3 === void 0 ? void 0 : _palette_common3.black
                }
            }
        }
    },
    MuiCheckbox: {
        styleOverrides: {
            root: {
                color: (_palette_grey6 = palette.grey) === null || _palette_grey6 === void 0 ? void 0 : _palette_grey6[50],
                padding: "8px",
                "&.Mui-checked": {
                    color: palette.primary,
                    padding: "8px"
                }
            }
        }
    },
    MuiFormControlLabel: {
        styleOverrides: {
            root: {
                margin: 0
            },
            label: {
                color: (_palette_text = palette.text) === null || _palette_text === void 0 ? void 0 : _palette_text.secondary,
                fontSize: "14px",
                lineHeight: "20px"
            }
        }
    },
    MuiFormLabel: {
        styleOverrides: {
            root: {
                color: (_palette_common4 = palette.common) === null || _palette_common4 === void 0 ? void 0 : _palette_common4.black,
                fontSize: "12px",
                fontWeight: 600,
                lineHeight: "22px"
            }
        }
    },
    MuiFilledInput: {
        styleOverrides: {
            root: {
                backgroundColor: (_palette_grey7 = palette.grey) === null || _palette_grey7 === void 0 ? void 0 : _palette_grey7[50],
                "&.Mui-readOnly": {
                    cursor: "default",
                    "& .MuiFilledInput-input": {
                        cursor: "default"
                    },
                    "&:hover, &:focus": {
                        backgroundColor: (_palette_grey8 = palette.grey) === null || _palette_grey8 === void 0 ? void 0 : _palette_grey8[50],
                        opacity: 1
                    }
                }
            }
        }
    },
    MuiSelect: {
        styleOverrides: {
            root: {
                "& .MuiSelect-select": {
                    padding: "8px 8px"
                }
            },
            icon: {
                right: "4px"
            }
        }
    }
};
var accountTheme = createTheme({
    breakpoints: breakpoints$1,
    palette: palette,
    typography: typography$1,
    components: components$1,
    spacing: 4
});

var ShareAndEarnButton = function(param) {
    var onClick = param.onClick;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(ThemeProvider, {
        theme: accountTheme,
        children: [
            /*#__PURE__*/ jsx(CssBaseline, {
                enableColorScheme: true
            }),
            /*#__PURE__*/ jsxs(Button, {
                variant: "contained",
                type: "button",
                onClick: onClick,
                sx: function(theme) {
                    return {
                        color: theme.palette.earn.contrastText,
                        backgroundColor: theme.palette.earn.main,
                        padding: {
                            xxs: "8px",
                            md: "6px 16px"
                        },
                        minWidth: {
                            xxs: "32px",
                            md: "137px"
                        },
                        ":hover": {
                            backgroundColor: theme.palette.earn.dark
                        }
                    };
                },
                children: [
                    /*#__PURE__*/ jsx(Icon, {
                        sx: {
                            fontSize: "16px"
                        },
                        component: Share
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "button",
                        sx: {
                            marginLeft: "8px",
                            display: {
                                xxs: "none",
                                md: "block"
                            }
                        },
                        children: t("ui.shareAndEarnButton", "Share & Earn")
                    })
                ]
            })
        ]
    });
};

var AVATAR_W = 80;
var AVATAR_H = 80;
var Avatar = function(param) {
    var src = param.src, alt = param.alt, _param_size = param.size, size = _param_size === void 0 ? 80 : _param_size;
    var srcWithDimensions = "".concat(src, "?d=").concat(AVATAR_W, "x").concat(AVATAR_H);
    return /*#__PURE__*/ jsx(Avatar$1, {
        src: srcWithDimensions,
        alt: alt,
        sx: {
            height: size,
            width: size
        },
        variant: "circular"
    });
};

function _define_property$r(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ButtonFollow = function(param) {
    var isFollowing = param.isFollowing, onClick = param.onClick;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Button$2, {
        onClick: onClick,
        variant: "text",
        color: isFollowing ? "primary" : "inherit",
        type: "button",
        sx: function(theme) {
            return _define_property$r({
                flexShrink: 0,
                fontSize: "1.6rem",
                width: "16rem",
                maxWidth: "40rem",
                margin: 0,
                marginTop: "20px",
                paddingLeft: 0,
                transition: "width 0.3s ease",
                textTransform: "none",
                position: "relative",
                overflow: "hidden",
                boxShadow: "none",
                "[:hover]": {
                    boxShadow: "none",
                    opacity: "0.8"
                }
            }, theme.breakpoints.down("md"), {
                padding: "0px"
            });
        },
        children: [
            isFollowing ? /*#__PURE__*/ jsx(SvgIcon, {
                sx: {
                    marginInlineEnd: "0.5rem",
                    fontSize: "2.4rem"
                },
                component: Follow,
                inheritViewBox: true
            }) : /*#__PURE__*/ jsx(ControlPointIcon, {
                sx: {
                    marginInlineEnd: "0.5rem",
                    fontSize: "2.4rem"
                }
            }),
            isFollowing ? t("components.buttonFollow.following", "Following") : t("components.buttonFollow.follow", "Follow")
        ]
    });
};

function _array_like_to_array$g(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$g(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$q(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$g(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$g() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$q(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$q(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array$g(arr, i) {
    return _array_with_holes$g(arr) || _iterable_to_array_limit$g(arr, i) || _unsupported_iterable_to_array$g(arr, i) || _non_iterable_rest$g();
}
function _unsupported_iterable_to_array$g(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$g(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$g(o, minLen);
}
var gapBetweenNumberAndCast = 0.07;
var castSize = 0.7;
var digitSpacing = -0.03;
function getFontSize(width, maxFontSize, value) {
    var digitHeightToWidthRatio = 1 / (0.681106061 + 1.997746213 * digitSpacing);
    var digitsCount = value.toString().length;
    var castWidth = castSize * digitHeightToWidthRatio;
    var gapInWidthRatio = gapBetweenNumberAndCast * digitHeightToWidthRatio;
    var fittingInWidthFontSize = digitHeightToWidthRatio * width / (digitsCount + gapInWidthRatio + castWidth);
    return Math.min(fittingInWidthFontSize, maxFontSize);
}
var defaultConfigs = function(numberValue, index) {
    return {
        mass: 1,
        tension: 400 - 30 * index,
        friction: 80
    };
};
var CastOdometer = function(param) {
    var value = param.value, _param_configs = param.configs, configs = _param_configs === void 0 ? defaultConfigs : _param_configs, fontStyle = param.fontStyle, iconSx = param.iconSx, containerSx = param.containerSx, _param_maxFontSize = param.maxFontSize, maxFontSize = _param_maxFontSize === void 0 ? 96 : _param_maxFontSize;
    var i18n = useTranslation().i18n;
    var _useReducer = _sliced_to_array$g(useReducer(function() {
        return {};
    }, {}), 2), rerender = _useReducer[1];
    var _useState = _sliced_to_array$g(useState(null), 2), container = _useState[0], setContainer = _useState[1];
    useEffect(function() {
        if (container) {
            var resizeObserver = new ResizeObserver(rerender);
            resizeObserver.observe(container);
            return function() {
                return resizeObserver.unobserve(container);
            };
        }
        return undefined;
    }, [
        container
    ]);
    var fontSize = container && getFontSize(container.clientWidth, maxFontSize, value);
    var _i18n_language;
    return /*#__PURE__*/ jsx(Stack, {
        direction: "row",
        gap: "".concat(gapBetweenNumberAndCast, "em"),
        alignItems: "center",
        justifyContent: "flex-end",
        height: maxFontSize,
        sx: _object_spread$q({
            fontSize: fontSize,
            fontWeight: 600,
            "&>.animated-container>div": {
                margin: "0 ".concat(digitSpacing, "em")
            }
        }, containerSx),
        ref: setContainer,
        children: !!fontSize && /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(AnimatedNumbers, {
                    animateToNumber: value,
                    configs: configs,
                    fontStyle: _object_spread$q({
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: maxFontSize
                    }, fontStyle),
                    locale: (_i18n_language = i18n.language) !== null && _i18n_language !== void 0 ? _i18n_language : "en-GB"
                }),
                /*#__PURE__*/ jsx(Icon, {
                    component: CastCredit,
                    sx: _object_spread$q({
                        fontSize: "".concat(castSize, "em")
                    }, iconSx)
                })
            ]
        })
    });
};

var Container$3 = styled(Stack)({
    alignItems: "stretch",
    width: "23px",
    minWidth: "23px",
    height: "46px",
    borderRadius: "2px",
    overflow: "clip"
});
var ArrowButton = styled(IconButton$1)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "9px",
        verticalAlign: "middle",
        flexGrow: 1,
        borderRadius: 0,
        background: theme.palette.grey[200],
        "&:hover": {
            background: theme.palette.grey[200]
        }
    };
});
var UpDownButtons = function(param) {
    var onUp = param.onUp, onDown = param.onDown, sx = param.sx;
    return /*#__PURE__*/ jsxs(Container$3, {
        sx: sx,
        children: [
            /*#__PURE__*/ jsx(ArrowButton, {
                type: "button",
                onClick: onUp,
                children: /*#__PURE__*/ jsx(IncrementTriangle, {})
            }),
            /*#__PURE__*/ jsx(ArrowButton, {
                type: "button",
                onClick: onDown,
                sx: {
                    transform: "rotate(180deg)"
                },
                children: /*#__PURE__*/ jsx(IncrementTriangle, {})
            })
        ]
    });
};

var StyledFilledInput$1 = styled$1(FilledInput)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.primary.contrastText,
        height: "48px",
        paddingRight: 0,
        fontSize: "24px",
        justifyContent: "center",
        input: {
            textAlign: "right",
            MozAppearance: "textfield",
            "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
                display: "none",
                margin: 0
            }
        }
    };
});
var NumberInput = function(param) {
    var value = param.value, setValue = param.setValue, unit = param.unit, uneditable = param.uneditable, error = param.error, onBlur = param.onBlur, sx = param.sx, _param_delta = param.delta, delta = _param_delta === void 0 ? 1 : _param_delta;
    return /*#__PURE__*/ jsx(StyledFilledInput$1, {
        type: "number",
        size: "small",
        hiddenLabel: true,
        disableUnderline: true,
        sx: sx,
        value: value,
        onChange: function(e) {
            return !uneditable && (setValue === null || setValue === void 0 ? void 0 : setValue(+e.target.value));
        },
        readOnly: uneditable,
        error: error,
        onBlur: onBlur,
        fullWidth: true,
        endAdornment: /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(Box, {
                    sx: {
                        "&>svg": {
                            fontSize: "0.75em"
                        }
                    },
                    children: unit
                }),
                /*#__PURE__*/ jsx(UpDownButtons, {
                    sx: {
                        opacity: 0,
                        pointerEvents: "none",
                        ".MuiInputBase-root:hover>&": !uneditable ? {
                            opacity: 1,
                            pointerEvents: "auto"
                        } : undefined
                    },
                    onUp: function() {
                        return setValue === null || setValue === void 0 ? void 0 : setValue(value + delta);
                    },
                    onDown: function() {
                        return setValue === null || setValue === void 0 ? void 0 : setValue(value - delta);
                    }
                })
            ]
        })
    });
};

var StyledFilledInput = styled$1(FilledInput)(function(param) {
    var theme = param.theme;
    var _theme_components_MuiFilledInput_styleOverrides, _theme_components_MuiFilledInput, _theme_components;
    return {
        color: theme.palette.primary.contrastText,
        height: "48px",
        fontSize: "24px",
        justifyContent: "center",
        textWrap: "nowrap",
        "&:hover": (_theme_components = theme.components) === null || _theme_components === void 0 ? void 0 : (_theme_components_MuiFilledInput = _theme_components.MuiFilledInput) === null || _theme_components_MuiFilledInput === void 0 ? void 0 : (_theme_components_MuiFilledInput_styleOverrides = _theme_components_MuiFilledInput.styleOverrides) === null || _theme_components_MuiFilledInput_styleOverrides === void 0 ? void 0 : _theme_components_MuiFilledInput_styleOverrides.root
    };
});
var ValueAsChildren = /*#__PURE__*/ forwardRef(function(param, _) {
    var value = param.value;
    return(// eslint-disable-next-line react/jsx-no-useless-fragment
    /*#__PURE__*/ jsx(Fragment, {
        children: value
    }));
});
var InputBox = /*#__PURE__*/ forwardRef(function(param, ref) {
    var uneditable = param.uneditable, error = param.error, children = param.children, sx = param.sx;
    return /*#__PURE__*/ jsx(StyledFilledInput, {
        ref: ref,
        components: {
            Input: ValueAsChildren
        },
        hiddenLabel: true,
        disableUnderline: true,
        sx: sx,
        value: children,
        readOnly: uneditable,
        error: error,
        fullWidth: true
    });
});

var Colors;
(function(Colors) {
    Colors["Primary"] = "#00e8d0";
    Colors["PrimaryBright"] = "#00FFE5";
    Colors["PrimaryDark"] = "#00C8B3";
    Colors["DarkPurple"] = "#5c0bfe";
    Colors["DarkTeal"] = "#008678";
    Colors["Green"] = "#28BD76";
    Colors["LightPurple"] = "#d936fe";
    Colors["RecastBlack"] = "#1e211d";
    Colors["RecastBlackHover"] = "#363F3D";
    Colors["Black"] = "#000000";
    Colors["OpacityBlack"] = "rgba(0, 0, 0, 0.87)";
    Colors["BackgroundApp"] = "#1a1a1a";
    Colors["BackgroundInputDark"] = "#343434";
    Colors["BackgroundInputWhite"] = "#f3f3f3";
    Colors["InputTextPlaceholderDark"] = "#9F9F9F";
    Colors["OpacityGray"] = "rgba(255,255,255,0.5)";
    Colors["LoaderOverlayOpacity"] = "rgba(0,0,0,0.15)";
    Colors["Gray"] = "#D9D9D9";
    Colors["GrayDark"] = "#8D8D8D";
    Colors["GrayDark2"] = "#303030";
    Colors["GrayDark3"] = "#454444";
    Colors["GrayDark4"] = "#30342F";
    Colors["GrayDark5"] = "#949494";
    Colors["ModalButtonGray"] = "#444444";
    Colors["ModalButtonGrayLight"] = "#CCCCCC";
    Colors["ModalButtonHoverFill"] = "#F0F0F0";
    Colors["DescriptionGray"] = "#797979";
    Colors["GrayLight"] = "#E7E7E7";
    Colors["White"] = "#fff";
    Colors["Error"] = "#f44336";
    Colors["Transparent"] = "rgba(0,0,0,0.0)";
    Colors["Blue"] = "#3233FF";
    Colors["Warning"] = "#FFA726";
    Colors["Info"] = "#29B6F6";
    Colors["Success"] = "#66BB6A";
    Colors["LiveHighlight100"] = "#FBFF98";
    Colors["LiveHighlight400"] = "#F4FF03";
    Colors["LiveHighlight700"] = "#E3ED00";
    Colors["SocialButtonBorder"] = "#E5E5E5";
    Colors["Radio"] = "#F3F3F3";
})(Colors || (Colors = {}));

function _array_like_to_array$f(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$f(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$p(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$f(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$f() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$p(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$p(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$m(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$m(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$m(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$c(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$c(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$c(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array$f(arr, i) {
    return _array_with_holes$f(arr) || _iterable_to_array_limit$f(arr, i) || _unsupported_iterable_to_array$f(arr, i) || _non_iterable_rest$f();
}
function _unsupported_iterable_to_array$f(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$f(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$f(o, minLen);
}
var InputRow = function(param) {
    var value = param.value, setValue = param.setValue, error = param.error, uneditable = param.uneditable, currencyValueWithSymbol = param.currencyValueWithSymbol, onBlur = param.onBlur, delta = param.delta;
    var _useTextFit = useTextFit(4), setContainer = _useTextFit.setContainer, setInner = _useTextFit.setInner;
    return /*#__PURE__*/ jsxs(Stack, {
        width: "278px",
        direction: "row",
        gap: "8px",
        justifyContent: "space-around",
        alignItems: "center",
        children: [
            /*#__PURE__*/ jsx(NumberInput, {
                sx: {
                    width: "120px",
                    fontSize: "24px",
                    fontWeight: 600,
                    color: Colors.RecastBlack
                },
                value: value,
                setValue: setValue,
                unit: /*#__PURE__*/ jsx(CastCredit, {
                    style: {
                        marginBottom: "4px",
                        marginLeft: "2px"
                    }
                }),
                error: error,
                uneditable: uneditable,
                onBlur: onBlur,
                delta: delta
            }),
            /*#__PURE__*/ jsx(Box, {
                sx: function(param) {
                    var palette = param.palette;
                    return {
                        fontSize: "16px",
                        color: palette.primary.contrastText
                    };
                },
                children: "="
            }),
            /*#__PURE__*/ jsx(InputBox, {
                ref: setContainer,
                sx: {
                    width: "120px",
                    backgroundColor: Colors.White,
                    "&:hover": {
                        backgroundColor: Colors.White,
                        color: Colors.RecastBlack
                    },
                    fontSize: "24px",
                    fontWeight: 600,
                    color: Colors.RecastBlack
                },
                uneditable: uneditable,
                children: /*#__PURE__*/ jsx("span", {
                    ref: setInner,
                    children: currencyValueWithSymbol
                })
            })
        ]
    });
};
var BottomTextBox = styled(Box)({
    fontSize: "12px",
    fontWeight: "400px",
    textAlign: "center",
    lineHeight: "10px"
});
var BoldZero = styled("span")(function(param) {
    var theme = param.theme;
    return {
        fontWeight: "bold",
        color: theme.palette.primary.contrastText
    };
});
var BoldNotZero = styled("span")(function(param) {
    var theme = param.theme;
    return {
        fontWeight: "bold",
        color: theme.palette.secondary.main
    };
});
var MIN_CAST_BONUS_VALUE = 200;
var MAX_CAST_BONUS_VALUE = 500;
var BottomText = function(param) {
    var value = param.value, bonus = param.bonus, error = param.error;
    var getContent = function() {
        if (value === MIN_CAST_BONUS_VALUE) {
            return /*#__PURE__*/ jsx(Trans, {
                i18nKey: "components.common.cast.castValue.minimumTopUpAmount",
                defaults: "Minimum top up amount"
            });
        } else if (value > MIN_CAST_BONUS_VALUE && value < MAX_CAST_BONUS_VALUE) {
            return /*#__PURE__*/ jsx(Trans, {
                i18nKey: "components.common.cast.castValue.zeroBonusCasts",
                components: {
                    b: /*#__PURE__*/ jsx(BoldZero, {})
                },
                defaults: "<b>0</b> Bonus Casts"
            });
        } else {
            return /*#__PURE__*/ jsx(Trans, {
                i18nKey: "components.common.cast.castValue.plusBonusCasts",
                components: {
                    b: /*#__PURE__*/ jsx(BoldNotZero, {})
                },
                defaults: "<b>+{{bonus}}</b> Bonus Casts. You will receive <b>{{total}}</b> Casts in total",
                values: {
                    bonus: bonus,
                    total: value + bonus
                }
            });
        }
    };
    var content = error !== null && error !== void 0 ? error : getContent();
    return /*#__PURE__*/ jsx(BottomTextBox, {
        sx: function(param) {
            var palette = param.palette;
            return {
                color: error ? palette.error.main : palette.text.secondary
            };
        },
        children: content
    });
};
var CastValue = function(param) {
    var value = param.value, setValue = param.setValue, paymentConfig = param.paymentConfig, error = param.error, uneditable = param.uneditable, onBlur = param.onBlur, delta = param.delta;
    return /*#__PURE__*/ jsxs(Stack, {
        width: "100%",
        gap: "12px",
        alignItems: "center",
        children: [
            /*#__PURE__*/ jsx(InputRow, {
                value: value,
                setValue: setValue,
                error: !!error,
                uneditable: !!uneditable,
                currencyValueWithSymbol: castsToCurrencyString(value, paymentConfig),
                onBlur: onBlur,
                delta: delta
            }),
            /*#__PURE__*/ jsx(BottomText, {
                value: value,
                bonus: getCastsBonus(value, paymentConfig),
                error: error
            })
        ]
    });
};
var FormikCastValue = function(_param) {
    var name = _param.name, castValueProps = _object_without_properties$c(_param, [
        "name"
    ]);
    var _useField = _sliced_to_array$f(useField(name), 3), field = _useField[0], meta = _useField[1], helpers = _useField[2];
    var error = meta.touched ? meta.error : undefined;
    return /*#__PURE__*/ jsx(CastValue, _object_spread_props$m(_object_spread$p({}, castValueProps), {
        value: field.value,
        setValue: helpers.setValue,
        onBlur: function() {
            return helpers.setTouched(true);
        },
        error: error
    }));
};

var THREE_DIGIT_AMOUNT = 999;
var CastAmount = function(param) {
    var amount = param.amount, _param_strikeThrough = param.strikeThrough, strikeThrough = _param_strikeThrough === void 0 ? false : _param_strikeThrough;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Box, {
        component: "span",
        sx: {
            alignItems: "baseline",
            position: "relative",
            "& > *": {
                margin: "0 0.02em"
            },
            "&:before": strikeThrough ? {
                content: '""',
                position: "absolute",
                width: amount > THREE_DIGIT_AMOUNT ? "4em" : "3.5em",
                height: "0.08em",
                transform: "translate(-0.5em, 0.7em)",
                backgroundColor: Colors.GrayDark3
            } : null
        },
        children: [
            /*#__PURE__*/ jsx(Box, {
                component: "span",
                children: amount
            }),
            /*#__PURE__*/ jsx(CastCredit, {
                fontSize: "0.65em",
                "aria-label": "Cast ".concat(t("components.common.cast.castAmount", "credit", {
                    count: amount
                }))
            })
        ]
    });
};

var BoxCenterRight = styled(Box)(function() {
    return {
        placeSelf: "center right",
        paddingRight: 4
    };
});
var BoxCenterLeft = styled(Box)(function() {
    return {
        placeSelf: "center left",
        paddingLeft: 4
    };
});
var CastCreditProgress = function(param) {
    var current = param.current, required = param.required;
    var t = useTranslation().t;
    var progress = percentageFrom(current, required, 0);
    var height = 20;
    return /*#__PURE__*/ jsxs(Box, {
        sx: {
            display: "grid",
            gridTemplate: '"wrapper"'
        },
        children: [
            /*#__PURE__*/ jsxs(Box, {
                sx: {
                    display: "grid",
                    gridTemplate: '"progress-header"',
                    overflow: "hidden",
                    "> *": {
                        gridArea: "progress-header"
                    }
                },
                children: [
                    /*#__PURE__*/ jsx(BoxCenterLeft, {
                        children: /*#__PURE__*/ jsx(Typography, {
                            variant: "body2",
                            children: /*#__PURE__*/ jsx("b", {
                                children: t("components.common.cast.castCreditProgress.youHave", "You have")
                            })
                        })
                    }),
                    /*#__PURE__*/ jsx(BoxCenterRight, {
                        children: /*#__PURE__*/ jsx(Typography, {
                            variant: "body2",
                            children: /*#__PURE__*/ jsx("b", {
                                children: t("components.common.cast.castCreditProgress.thisCosts", "This costs")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ jsxs(Box, {
                sx: {
                    display: "grid",
                    gridTemplate: '"progress-container"',
                    overflow: "hidden",
                    "> *": {
                        gridArea: "progress-container"
                    }
                },
                children: [
                    /*#__PURE__*/ jsx(BoxCenterLeft, {
                        sx: {
                            zIndex: 1
                        },
                        children: /*#__PURE__*/ jsx(Typography, {
                            color: "common.black",
                            variant: "body1",
                            children: /*#__PURE__*/ jsx(CastAmount, {
                                amount: Math.floor(current)
                            })
                        })
                    }),
                    /*#__PURE__*/ jsx(BoxCenterRight, {
                        sx: {
                            zIndex: 1
                        },
                        children: /*#__PURE__*/ jsx(Typography, {
                            color: "common.black",
                            variant: "body1",
                            children: /*#__PURE__*/ jsx(CastAmount, {
                                amount: Math.floor(required)
                            })
                        })
                    }),
                    /*#__PURE__*/ jsx(LinearProgress, {
                        variant: "determinate",
                        value: progress,
                        sx: {
                            height: height
                        },
                        title: "Cast credits needed"
                    })
                ]
            })
        ]
    });
};

function _define_property$o(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$o(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$o(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$l(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$l(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$l(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var allowedDimensions = [
    {
        w: 40,
        h: 40
    },
    {
        w: 80,
        h: 80
    },
    {
        w: 136,
        h: 70
    },
    {
        w: 180,
        h: 80
    },
    {
        w: 128,
        h: 128
    },
    {
        w: 248,
        h: 180
    },
    {
        w: 180,
        h: 128
    },
    {
        w: 328,
        h: 184
    },
    {
        w: 220,
        h: 124
    },
    {
        w: 288,
        h: 112
    },
    {
        w: 256,
        h: 256
    },
    {
        w: 360,
        h: 160
    },
    {
        w: 272,
        h: 140
    },
    {
        w: 160,
        h: 160
    },
    {
        w: 496,
        h: 360
    },
    {
        w: 360,
        h: 256
    },
    {
        w: 656,
        h: 368
    },
    {
        w: 440,
        h: 248
    },
    {
        w: 576,
        h: 224
    },
    {
        w: 180,
        h: 180
    },
    {
        w: 240,
        h: 180
    },
    {
        w: 320,
        h: 180
    },
    {
        w: 360,
        h: 360
    },
    {
        w: 480,
        h: 360
    },
    {
        w: 640,
        h: 360
    },
    {
        w: 640,
        h: 480
    },
    {
        w: 854,
        h: 480
    },
    {
        w: 640,
        h: 640
    },
    {
        w: 853,
        h: 640
    },
    {
        w: 1138,
        h: 640
    },
    {
        w: 1440,
        h: 1080
    },
    {
        w: 1920,
        h: 1080
    }
].sort(function(a, b) {
    return a.w - b.w || a.h - b.h;
});
function getClosestBiggerDimension(width, height) {
    var dimensions = allowedDimensions.find(function(dimensions) {
        return dimensions.w >= width && dimensions.h >= height;
    });
    return dimensions !== null && dimensions !== void 0 ? dimensions : allowedDimensions.at(-1);
}
function Image(props) {
    var src = props.src, width = props.width, height = props.height;
    var _getClosestBiggerDimension = getClosestBiggerDimension(width, height), w = _getClosestBiggerDimension.w, h = _getClosestBiggerDimension.h;
    var srcWithDimensions = src && "".concat(src, "?d=").concat(w, "x").concat(h);
    // eslint-disable-next-line jsx-a11y/alt-text
    return /*#__PURE__*/ jsx("img", _object_spread_props$l(_object_spread$o({}, props), {
        src: srcWithDimensions,
        loading: "lazy"
    }));
}

var StyledChannelHeader = styled("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        padding: "0"
    };
});
var StyledChannelDetails = styled("div")(function() {
    return {
        marginRight: "32px",
        overflow: "hidden",
        whiteSpace: "nowrap"
    };
});
function ChannelHeader(param) {
    var channelName = param.channelName, channelLogo = param.channelLogo, channelSubtitle = param.channelSubtitle;
    var isMobile = useMediaQuery(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var channelNameFontSize = isMobile ? "14px" : "36px";
    var channelLogoSize = isMobile ? 32 : 64;
    var channelNameLineHeight = isMobile ? "16px" : "44px";
    var channelNamePaddingTop = isMobile ? "6px" : "0";
    var channelDescription = isMobile ? "" : channelSubtitle;
    return /*#__PURE__*/ jsxs(StyledChannelHeader, {
        children: [
            /*#__PURE__*/ jsx(Image, {
                style: {
                    borderRadius: "3px",
                    marginRight: "12px"
                },
                src: channelLogo,
                alt: channelName,
                width: channelLogoSize,
                height: channelLogoSize
            }),
            /*#__PURE__*/ jsxs(StyledChannelDetails, {
                children: [
                    /*#__PURE__*/ jsx(Typography, {
                        sx: {
                            fontWeight: 600,
                            fontSize: channelNameFontSize,
                            lineHeight: channelNameLineHeight,
                            paddingTop: channelNamePaddingTop,
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        children: channelName
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "body2",
                        sx: {
                            fontSize: "12px",
                            fontWeight: 300,
                            lineHeight: "16px",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        children: channelDescription
                    })
                ]
            })
        ]
    });
}

function _define_property$n(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$n(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$n(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$k(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$k(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$k(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var CheckboxCheckedIcon = function(props) {
    return /*#__PURE__*/ jsxs("svg", _object_spread_props$k(_object_spread$n({
        className: props.className,
        viewBox: "0 0 24 24",
        role: "img"
    }, props), {
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: props.color ? props.color : "currentColor",
                d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: props.tickColour ? props.tickColour : "#1e211d",
                d: "M10 17L5 12l1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            })
        ]
    }));
};

function _define_property$m(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$m(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$m(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$j(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$j(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$j(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var CheckboxUncheckedIcon = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$j(_object_spread$m({
        className: props.className,
        viewBox: "0 0 24 24",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("rect", {
            fill: props.color ? props.color : "currentColor",
            x: "3",
            y: "3",
            width: "18",
            height: "18",
            rx: "2"
        })
    }));
};

function _array_like_to_array$e(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$e(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$l(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$e(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$e() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$l(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$l(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$i(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$i(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$i(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$b(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$b(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$b(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array$e(arr, i) {
    return _array_with_holes$e(arr) || _iterable_to_array_limit$e(arr, i) || _unsupported_iterable_to_array$e(arr, i) || _non_iterable_rest$e();
}
function _unsupported_iterable_to_array$e(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$e(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$e(o, minLen);
}
function Checkbox(param) {
    var label = param.label, checkboxProps = param.checkboxProps, sx = param.sx, _param_error = param.error, error = _param_error === void 0 ? false : _param_error;
    var isRtl = document.dir === "rtl";
    var theme = useTheme();
    var iconProps = {
        sx: {
            width: "16px",
            height: "16px"
        },
        stroke: error ? theme.palette.error.main : "",
        strokeWidth: "2px"
    };
    return /*#__PURE__*/ jsx(FormControlLabel, {
        labelPlacement: isRtl ? "start" : "end",
        sx: sx,
        control: /*#__PURE__*/ jsx(Checkbox$1, _object_spread$l({
            indeterminate: false,
            icon: /*#__PURE__*/ jsx(Icon, _object_spread$l({
                component: CheckboxUncheckedIcon
            }, iconProps)),
            checkedIcon: /*#__PURE__*/ jsx(Icon, _object_spread$l({
                component: CheckboxCheckedIcon
            }, iconProps))
        }, checkboxProps)),
        label: label
    });
}
var FormikCheckbox = function(_param) {
    var name = _param.name, checkboxProps = _param.checkboxProps, props = _object_without_properties$b(_param, [
        "name",
        "checkboxProps"
    ]);
    var _useField = _sliced_to_array$e(useField(name), 1), field = _useField[0];
    return /*#__PURE__*/ jsx(Checkbox, _object_spread_props$i(_object_spread$l({}, props), {
        checkboxProps: _object_spread$l({
            name: field.name,
            checked: field.value,
            onChange: field.onChange
        }, checkboxProps)
    }));
};

function CodeBox(param) {
    var code = param.code;
    return /*#__PURE__*/ jsx(Box, {
        sx: {
            fontSize: "12px",
            flexGrow: 1,
            color: "#fff",
            fontWeight: 300,
            backgroundColor: "#1a1a1a",
            padding: "12px 30px",
            margin: "0px 4px",
            borderRadius: "2px",
            wordBreak: "break-all",
            lineHeight: "1.2"
        },
        children: code
    });
}

function _array_like_to_array$d(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$d(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit$d(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$d() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$d(arr, i) {
    return _array_with_holes$d(arr) || _iterable_to_array_limit$d(arr, i) || _unsupported_iterable_to_array$d(arr, i) || _non_iterable_rest$d();
}
function _unsupported_iterable_to_array$d(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$d(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$d(o, minLen);
}
function _ts_generator$1(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var MIN_CHARS = 1;
var MAX_CHARS = 2000;
var POST_TOOLS_HEIGHT = 60;
var BUTTON_HEIGHT = 42;
var BUTTON_MARGIN = 3;
var INPUT_PADDING = 10;
var StyledTextField = styled$1(TextField)(function(param) {
    var theme = param.theme;
    return {
        marginRight: "5px",
        fontSize: "14px",
        lineHeight: "1.5",
        width: "100%",
        "& .MuiInputBase-root": {
            display: "flex",
            alignItems: "start",
            padding: "0",
            border: "none",
            "&::before": {
                border: "none !important"
            },
            "&::after": {
                border: "none !important"
            }
        },
        "& .MuiInputBase-input": {
            padding: "".concat(INPUT_PADDING, "px 16px"),
            borderRadius: "3px",
            backgroundColor: theme.palette.common.white
        }
    };
});
var StyledIconButton = styled$1(IconButton$1)(function(param) {
    var theme = param.theme;
    return {
        borderRadius: "3px",
        width: "60px",
        height: "".concat(BUTTON_HEIGHT, "px"),
        backgroundColor: theme.palette.primary.main,
        alignSelf: "flex-end",
        "&.Mui-disabled": {
            backgroundColor: "grey"
        }
    };
});
var StyledForm$1 = styled$1(Form, {
    shouldForwardProp: function(prop) {
        return prop !== "isInputExtended";
    }
})(function(param) {
    var isInputExtended = param.isInputExtended;
    return {
        display: "flex",
        width: "100%",
        height: "100%",
        maxHeight: "100%",
        alignItems: isInputExtended ? "normal" : "flex-end",
        flexDirection: isInputExtended ? "column" : "row",
        backgroundColor: isInputExtended ? "white" : "transparent",
        justifyContent: "space-between",
        pointerEvents: "none",
        "& > *": {
            pointerEvents: "auto"
        }
    };
});
var StyledStack$2 = styled$1(Stack)({
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#404040",
    borderRadius: "3px",
    height: "39px",
    width: "100%"
});
function CommentInput(param) {
    var _param_comment = param.comment, comment = _param_comment === void 0 ? "" : _param_comment, writePermission = param.writePermission, onSubmit = param.onSubmit;
    var t = useTranslation().t;
    var _useState = _sliced_to_array$d(useState(!!comment), 2), isInputExtended = _useState[0], setIsInputExtended = _useState[1];
    var _useState1 = _sliced_to_array$d(useState(0), 2), height = _useState1[0], setHeight = _useState1[1];
    var containerRef = useRef(null);
    useEffect(function() {
        var _containerRef_current;
        if (containerRef === null || containerRef === void 0 ? void 0 : (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.clientHeight) {
            var _containerRef_current1;
            var _getComputedStyle = getComputedStyle(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current), paddingTop = _getComputedStyle.paddingTop, paddingBottom = _getComputedStyle.paddingBottom;
            var verticalPadding = extractPaddingAsNumber(paddingTop) + extractPaddingAsNumber(paddingBottom);
            setHeight((containerRef === null || containerRef === void 0 ? void 0 : (_containerRef_current1 = containerRef.current) === null || _containerRef_current1 === void 0 ? void 0 : _containerRef_current1.clientHeight) - verticalPadding);
        }
    }, [
        containerRef
    ]);
    if (!writePermission) {
        return /*#__PURE__*/ jsx(StyledStack$2, {
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                sx: function(theme) {
                    return {
                        color: theme.palette.text.secondary
                    };
                },
                children: t("components.commentInput.buyVideo", "Buy the video to leave a comment")
            })
        });
    }
    var onFormSubmit = function() {
        var _ref = _async_to_generator$1(function(param, param1) {
            var comment, setFieldError, resetForm;
            return _ts_generator$1(this, function(_state) {
                switch(_state.label){
                    case 0:
                        comment = param.comment, setFieldError = param1.setFieldError, resetForm = param1.resetForm;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            onSubmit(comment)
                        ];
                    case 2:
                        _state.sent();
                        setIsInputExtended(false);
                        resetForm();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _state.sent();
                        setFieldError("comment", t("components.commentInput.apiError", "issue posting comment"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFormSubmit(_, _1) {
            return _ref.apply(this, arguments);
        };
    }();
    var calcRows = function(height, isInputExtended) {
        if (height && isInputExtended) {
            var muiRowHeight = 23;
            var buttonTotal = BUTTON_HEIGHT + BUTTON_MARGIN * 2;
            return Math.floor((height - (buttonTotal + POST_TOOLS_HEIGHT + INPUT_PADDING * 2)) / muiRowHeight);
        }
        return 1;
    };
    return /*#__PURE__*/ jsxs(Box, {
        ref: containerRef,
        sx: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            display: "flex",
            flexDirection: isInputExtended ? "column" : "row",
            justifyContent: isInputExtended ? "flex-start" : "flex-end",
            alignItems: "flex-end",
            height: "100%",
            maxHeight: "100%",
            backgroundColor: "transparent",
            pointerEvents: "none",
            padding: "inherit",
            "& > *": {
                pointerEvents: "auto"
            }
        },
        children: [
            isInputExtended && /*#__PURE__*/ jsx(Box, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    minHeight: "60px",
                    height: "".concat(POST_TOOLS_HEIGHT, "px"),
                    width: "100%",
                    backgroundColor: "#CBCBCB",
                    borderRadius: "3px 3px 0 0"
                },
                children: /*#__PURE__*/ jsx("span", {
                    style: {
                        cursor: "pointer"
                    },
                    onClick: function() {
                        return isInputExtended && setIsInputExtended(false);
                    },
                    children: t("components.commentInput.close", "Close")
                })
            }),
            /*#__PURE__*/ jsx(Formik, {
                validateOnMount: true,
                validateOnChange: true,
                initialValues: {
                    comment: comment
                },
                onSubmit: onFormSubmit,
                validate: function(param) {
                    var comment = param.comment;
                    var errors = {};
                    if (comment.length < MIN_CHARS || comment.length > MAX_CHARS) {
                        errors.comment = t("components.commentInput.charError", "comments must be between {{min}} and {{max}} characters", {
                            min: MIN_CHARS,
                            max: MAX_CHARS
                        });
                    }
                    return errors;
                },
                children: function(param) {
                    var values = param.values, errors = param.errors, isSubmitting = param.isSubmitting, handleChange = param.handleChange;
                    return /*#__PURE__*/ jsxs(StyledForm$1, {
                        isInputExtended: isInputExtended,
                        children: [
                            /*#__PURE__*/ jsx(StyledTextField, {
                                name: "comment",
                                value: values.comment,
                                multiline: true,
                                placeholder: t("components.commentInput.placeholder", "Leave a comment"),
                                onClick: function() {
                                    return !isInputExtended && setIsInputExtended(true);
                                },
                                onChange: handleChange,
                                inputProps: {
                                    maxLength: MAX_CHARS
                                },
                                sx: {
                                    marginRight: isInputExtended ? "0px" : "5px"
                                },
                                rows: calcRows(height, isInputExtended)
                            }),
                            /*#__PURE__*/ jsx(StyledIconButton, {
                                type: "submit",
                                disabled: isSubmitting || !!errors.comment,
                                children: /*#__PURE__*/ jsx(PlayArrow, {
                                    sx: {
                                        height: "10px",
                                        color: "common.black"
                                    }
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
}

var StyledDrawer = styled$1(Drawer$1)(function(param) {
    var open = param.open;
    return {
        userSelect: "none",
        "&.MuiDrawer-docked": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: open ? "rgba(0, 0, 0, 0.5)" : "transparent"
        },
        "& .MuiPaper-root": {
            position: "absolute",
            background: "none"
        }
    };
});
function NestedDrawer(param) {
    var anchor = param.anchor, open = param.open, onClose = param.onClose, children = param.children;
    return /*#__PURE__*/ jsx(StyledDrawer, {
        open: open,
        anchor: anchor,
        variant: "persistent",
        transitionDuration: 0,
        onClick: function(e) {
            return e.currentTarget === e.target && onClose();
        },
        sx: {
            pointerEvents: open ? "auto" : "none"
        },
        children: children
    });
}

var Option = function(param) {
    var text = param.text, icon = param.icon, onClick = param.onClick;
    return /*#__PURE__*/ jsxs(MenuItem, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ jsx(ListItemIcon, {
                children: icon
            }),
            /*#__PURE__*/ jsx(ListItemText, {
                sx: {
                    color: function(theme) {
                        return theme.palette.common.black;
                    }
                },
                children: text
            })
        ]
    });
};
var CommentOptions = function(param) {
    var userId = param.userId, postId = param.postId, selfPosted = param.selfPosted, isAdminOrMod = param.isAdminOrMod, channelId = param.channelId, username = param.username, onAction = param.onAction, onClose = param.onClose;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(NestedDrawer, {
        anchor: "bottom",
        open: true,
        onClose: onClose,
        children: /*#__PURE__*/ jsxs(MenuList, {
            children: [
                (selfPosted || isAdminOrMod) && /*#__PURE__*/ jsx(Option, {
                    text: t("components.commentOptions.deleteComment", "Delete Comment"),
                    icon: /*#__PURE__*/ jsx(Delete, {}),
                    onClick: function() {
                        onAction({
                            type: "delete-comment",
                            payload: {
                                postId: postId,
                                username: username
                            }
                        });
                        onClose();
                    }
                }),
                !selfPosted && !isAdminOrMod && /*#__PURE__*/ jsx(Option, {
                    text: t("components.commentOptions.flagComment", "Flag this comment"),
                    icon: /*#__PURE__*/ jsx(Flag, {}),
                    onClick: function() {
                        onAction({
                            type: "flag-comment",
                            payload: {
                                postId: postId
                            }
                        });
                        onClose();
                    }
                }),
                isAdminOrMod && !selfPosted && /*#__PURE__*/ jsx(Option, {
                    text: t("components.commentOptions.banUser", "Ban user"),
                    icon: /*#__PURE__*/ jsx(Block, {}),
                    onClick: function() {
                        onAction({
                            type: "ban-comment",
                            payload: {
                                userId: userId,
                                channelId: channelId,
                                username: username
                            }
                        });
                        onClose();
                    }
                })
            ]
        })
    });
};

var TextAvatar = function(param) {
    var username = param.username;
    return /*#__PURE__*/ jsx(Avatar$1, {
        sx: {
            backgroundColor: stringToColor(username)
        },
        children: stringToOneChar(username)
    });
};

var StyledListItem = styled(ListItem)(function(param) {
    var theme = param.theme;
    return {
        maxWidth: "none",
        color: theme.palette.common.white
    };
});
var StyledTypography$1 = styled(Typography)({
    display: "inline-block",
    width: "100%",
    marginBottom: "18px",
    wordBreak: "break-all"
});
function Comment(param) {
    var postId = param.postId, userId = param.userId, username = param.username, postedDate = param.postedDate, nowDate = param.nowDate, content = param.content, selfPost = param.selfPost, isAdminOrMod = param.isAdminOrMod, deleted = param.deleted, channelId = param.channelId, displayCommentOptions = param.displayCommentOptions, onOptionsClick = param.onOptionsClick;
    return deleted ? /*#__PURE__*/ jsx(StyledListItem, {
        children: "This comment has been deleted"
    }, postId) : /*#__PURE__*/ jsxs(StyledListItem, {
        secondaryAction: displayCommentOptions && /*#__PURE__*/ jsx(Box, {
            sx: {
                display: "flex",
                justifyContent: "flex-end"
            },
            children: /*#__PURE__*/ jsx(IconButton$1, {
                onClick: function() {
                    onOptionsClick({
                        postId: postId,
                        selfPost: selfPost,
                        isAdminOrMod: isAdminOrMod,
                        userId: userId,
                        channelId: channelId,
                        username: username
                    });
                },
                children: /*#__PURE__*/ jsx(MoreVert, {
                    sx: {
                        // TODO: Use common grey once implemented
                        color: "grey.500",
                        height: "13px"
                    }
                })
            })
        }),
        children: [
            /*#__PURE__*/ jsx(ListItemAvatar, {
                children: /*#__PURE__*/ jsx(TextAvatar, {
                    username: username
                })
            }),
            /*#__PURE__*/ jsx(ListItemText, {
                primary: /*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ jsx(Typography, {
                            sx: {
                                display: "inline",
                                marginRight: "10px"
                            },
                            variant: "subtitle2",
                            children: username
                        }),
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "caption",
                            children: timeBetween(postedDate, nowDate)
                        })
                    ]
                }),
                secondary: /*#__PURE__*/ jsx(StyledTypography$1, {
                    variant: "caption",
                    children: content
                })
            })
        ]
    });
}

function _define_property$k(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$k(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$k(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$h(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$h(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$h(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var Dialog = function(props) {
    var children = props.children;
    return /*#__PURE__*/ jsx(Dialog$1, _object_spread_props$h(_object_spread$k({}, props), {
        children: children
    }));
};

var styles = {
    "drawer": "Drawer-module_drawer__0RFo2",
    "header-bar": "Drawer-module_header-bar__YxtTN",
    "title": "Drawer-module_title__olfIk",
    "children": "Drawer-module_children__cJDTl"
};

var Drawer = function(param) {
    var children = param.children, _param_closeColor = param.closeColor, closeColor = _param_closeColor === void 0 ? "#fff" : _param_closeColor, title = param.title, onClose = param.onClose, customHeaderElement = param.customHeaderElement, drawerClassName = param.drawerClassName, headerBarClassName = param.headerBarClassName;
    return /*#__PURE__*/ jsxs("div", {
        className: "".concat(styles["drawer"], " ").concat(drawerClassName !== null && drawerClassName !== void 0 ? drawerClassName : ""),
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: "".concat(styles["drawer"], " ").concat(styles["header-bar"], " ").concat(headerBarClassName !== null && headerBarClassName !== void 0 ? headerBarClassName : ""),
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: styles["title"],
                        children: [
                            /*#__PURE__*/ jsx("span", {
                                children: title
                            }),
                            customHeaderElement
                        ]
                    }),
                    /*#__PURE__*/ jsx("button", {
                        type: "button",
                        "aria-label": "close",
                        onClick: onClose,
                        children: /*#__PURE__*/ jsx(Close, {
                            color: closeColor
                        })
                    })
                ]
            }),
            children ? /*#__PURE__*/ jsx("div", {
                className: "".concat(styles["drawer"], " ").concat(styles["children"]),
                children: children
            }) : null
        ]
    });
};

function _define_property$j(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$j(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$j(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$g(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$g(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$g(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ExternalLink = function(props) {
    return /*#__PURE__*/ jsx(Link, _object_spread_props$g(_object_spread$j({
        sx: {
            cursor: "pointer"
        },
        target: "_blank",
        rel: "noopener noreferrer"
    }, props), {
        children: props.children
    }));
};

var Container$2 = styled(Box)(function(param) {
    var theme = param.theme;
    return {
        background: alpha(theme.palette.primary.main, 0.2),
        padding: "8px 12px",
        borderRadius: "2px",
        display: "flex",
        gap: "12px",
        justifyContent: "space-between",
        alignItems: "center"
    };
});
var Buttons = styled(Box)({
    display: "flex",
    gap: "4px"
});
var StyledButton$4 = styled(Button)(function(param) {
    var theme = param.theme, variant = param.variant;
    return variant === "outlined" ? {
        color: theme.palette.text.primary,
        borderColor: theme.palette.text.primary
    } : {};
});
function FieldPrompt(param) {
    var children = param.children, buttons = param.buttons, sx = param.sx;
    return /*#__PURE__*/ jsxs(Container$2, {
        sx: sx,
        children: [
            /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                children: children
            }),
            /*#__PURE__*/ jsx(Buttons, {
                children: buttons.map(function(param, i) {
                    var label = param.label, onClick = param.onClick, _param_variant = param.variant, variant = _param_variant === void 0 ? "contained" : _param_variant;
                    return /*#__PURE__*/ jsx(StyledButton$4, {
                        onClick: onClick,
                        size: "small",
                        variant: variant,
                        children: label
                    }, i);
                })
            })
        ]
    });
}

function FormApiErrorText(props) {
    var apiError = props.apiError, isFormLocallyValid = props.isFormLocallyValid, supportEmail = props.supportEmail;
    var t = useTranslation().t;
    var translatedMessage = useMemo(function() {
        var _apiError_message;
        return t("api.errors.".concat(apiError === null || apiError === void 0 ? void 0 : apiError.type), {
            defaultValue: (_apiError_message = apiError === null || apiError === void 0 ? void 0 : apiError.message) !== null && _apiError_message !== void 0 ? _apiError_message : "Unknown Error",
            replace: {
                supportEmail: supportEmail !== null && supportEmail !== void 0 ? supportEmail : ""
            }
        });
    }, [
        apiError,
        supportEmail,
        t
    ]);
    var renderText = function() {
        if (!!apiError && isFormLocallyValid) {
            return translatedMessage;
        }
        return " ";
    };
    return /*#__PURE__*/ jsx(FormHelperText, {
        error: true,
        sx: {
            textAlign: "center",
            marginBottom: "10px"
        },
        children: renderText()
    });
}
function FormikFormApiErrorText(props) {
    var apiError = props.apiError;
    var isFormLocallyValid = useFormikContext().isValid;
    return /*#__PURE__*/ jsx(FormApiErrorText, {
        isFormLocallyValid: isFormLocallyValid,
        apiError: apiError,
        supportEmail: props.supportEmail
    });
}

function _array_like_to_array$c(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$c(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes$1(arr) {
    if (Array.isArray(arr)) return _array_like_to_array$c(arr);
}
function _define_property$i(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit$c(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$c() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$i(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$i(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$f(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$f(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$f(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$a(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$a(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$a(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array$c(arr, i) {
    return _array_with_holes$c(arr) || _iterable_to_array_limit$c(arr, i) || _unsupported_iterable_to_array$c(arr, i) || _non_iterable_rest$c();
}
function _to_consumable_array$1(arr) {
    return _array_without_holes$1(arr) || _iterable_to_array$1(arr) || _unsupported_iterable_to_array$c(arr) || _non_iterable_spread$1();
}
function _unsupported_iterable_to_array$c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$c(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$c(o, minLen);
}
var StyledFilledCodeInput = styled$1(FilledInput)(function(param) {
    var theme = param.theme;
    return {
        "& input": _define_property$i({
            display: "inline-flex",
            flexGrow: 0,
            flexShrink: 0,
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "600",
            textAlign: "center",
            padding: 0,
            fontSize: "24px",
            flexBasis: "48px",
            width: "48px",
            height: "48px"
        }, theme.breakpoints.up("sm"), {
            fontSize: "32px",
            flexBasis: "64px",
            width: "64px",
            height: "64px"
        })
    };
});
var FormCodeInput = function(props) {
    var length = props.length, value = props.value, onChange = props.onChange, error = props.error, helperText = props.helperText, disabled = props.disabled, isUppercased = props.isUppercased, containerSx = props.containerSx, onKeyDown = props.onKeyDown;
    var inputRefs = useRef(Array(length).fill(null).map(function() {
        return /*#__PURE__*/ createRef();
    }));
    var inputValues = Array(length).fill("").map(function(_, i) {
        var char = value[i];
        return char ? char : "";
    });
    var deleteAt = function(index) {
        var copiedValues = _to_consumable_array$1(inputValues);
        copiedValues[index] = "";
        onChange(copiedValues.join(""));
    };
    var switchTo = function(index) {
        var input = inputRefs.current[index];
        if (input && input.current) {
            input.current.getElementsByTagName("input")[0].focus();
            input.current.getElementsByTagName("input")[0].setSelectionRange(0, 1);
        }
    };
    var handleChange = function(value, index) {
        if (value === "") {
            return;
        }
        var copiedValues = _to_consumable_array$1(inputValues);
        var finalIndex = index + 1;
        if (value.length > 1) {
            value.split("").forEach(function(char, i) {
                var nextIndex = index + i;
                if (nextIndex < copiedValues.length) {
                    copiedValues[nextIndex] = char;
                    finalIndex = nextIndex;
                }
            });
        } else {
            copiedValues[index] = value;
        }
        switchTo(finalIndex);
        onChange(copiedValues.join(""));
    };
    var handleKeyDown = function(key, index) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(key);
        switch(key){
            case "Backspace":
                deleteAt(index);
                switchTo(index - 1);
                break;
            case "Delete":
                deleteAt(index);
                break;
            case "ArrowLeft":
            case "ArrowUp":
                switchTo(index - 1);
                break;
            case "ArrowRight":
            case "ArrowDown":
                switchTo(index + 1);
                break;
        }
    };
    return /*#__PURE__*/ jsxs(Box, {
        sx: _object_spread$i({
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
        }, containerSx),
        children: [
            /*#__PURE__*/ jsx(Box, {
                sx: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    gap: "8px"
                },
                children: inputValues.map(function(value, i) {
                    return /*#__PURE__*/ jsx(StyledFilledCodeInput, {
                        ref: inputRefs.current[i],
                        onChange: function(event) {
                            return handleChange(event.target.value, i);
                        },
                        onKeyDown: function(event) {
                            return handleKeyDown(event.key, i);
                        },
                        value: value,
                        disabled: disabled,
                        type: "text",
                        placeholder: "-",
                        hiddenLabel: true,
                        disableUnderline: true,
                        inputProps: {
                            sx: {
                                textTransform: isUppercased ? "uppercase" : "none"
                            }
                        }
                    }, i);
                })
            }),
            /*#__PURE__*/ jsx(FormHelperText, {
                error: error,
                sx: {
                    textAlign: "center",
                    margin: "0px"
                },
                children: helperText !== null && helperText !== void 0 ? helperText : " "
            })
        ]
    });
};
var FormikFormCodeInput = function(props) {
    var name = props.name, formCodeInputProps = _object_without_properties$a(props, [
        "name"
    ]);
    var _useField = _sliced_to_array$c(useField(name), 2), field = _useField[0], meta = _useField[1];
    return /*#__PURE__*/ jsx(FormCodeInput, _object_spread_props$f(_object_spread$i({}, formCodeInputProps), {
        value: field.value,
        onChange: function(value) {
            return field.onChange({
                target: {
                    value: value,
                    name: field.name
                }
            });
        },
        error: meta.touched && Boolean(meta.error),
        helperText: meta.touched ? meta.error : undefined
    }));
};

function _array_like_to_array$b(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$b(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$h(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$b(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$b() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$h(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$h(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$e(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$e(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$e(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$9(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$9(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$9(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array$b(arr, i) {
    return _array_with_holes$b(arr) || _iterable_to_array_limit$b(arr, i) || _unsupported_iterable_to_array$b(arr, i) || _non_iterable_rest$b();
}
function _unsupported_iterable_to_array$b(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$b(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$b(o, minLen);
}
var CalendarIcon = styled(Calendar)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.text.primary,
        width: 16,
        height: 16
    };
});
var FormDatePicker = function(props) {
    var label = props.label, sx = props.sx, onClear = props.onClear, datePickerProps = _object_without_properties$9(props, [
        "label",
        "sx",
        "onClear"
    ]);
    return /*#__PURE__*/ jsxs(LocalizationProvider, {
        dateAdapter: AdapterDateFns,
        children: [
            /*#__PURE__*/ jsxs(InputLabel, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                htmlFor: datePickerProps.name,
                children: [
                    label,
                    onClear && /*#__PURE__*/ jsx(IconButton$1, {
                        disableRipple: true,
                        sx: {
                            padding: "6px 0 6px 6px"
                        },
                        onClick: onClear,
                        children: /*#__PURE__*/ jsx(Icon, {
                            component: HighlightOff,
                            sx: {
                                fontSize: 12
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ jsx(DatePicker, _object_spread_props$e(_object_spread$h({}, datePickerProps), {
                slots: {
                    openPickerIcon: CalendarIcon
                },
                slotProps: {
                    textField: {
                        variant: "filled",
                        InputProps: {
                            disableUnderline: true
                        },
                        fullWidth: true,
                        sx: _object_spread_props$e(_object_spread$h({}, sx), {
                            ".MuiInputBase-input": {
                                padding: "9px 0px 9px 10px"
                            },
                            ".MuiInputBase-root": {
                                paddingRight: "24px"
                            }
                        })
                    }
                }
            }))
        ]
    });
};
var FormikFormDatePicker = function(props) {
    var name = props.name, isWithClear = props.isWithClear, formInputProps = _object_without_properties$9(props, [
        "name",
        "isWithClear"
    ]);
    var _useField = _sliced_to_array$b(useField(name), 3), field = _useField[0], helper = _useField[2];
    return /*#__PURE__*/ jsx(FormDatePicker, _object_spread_props$e(_object_spread$h({}, formInputProps), {
        name: name,
        value: field.value,
        onChange: function(value) {
            return helper.setValue(value);
        },
        onClear: isWithClear ? function() {
            return helper.setValue(null);
        } : undefined
    }));
};

function _array_like_to_array$a(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$a(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$g(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$a(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$a() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$g(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$g(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$d(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$d(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$d(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$8(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$8(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$8(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array$a(arr, i) {
    return _array_with_holes$a(arr) || _iterable_to_array_limit$a(arr, i) || _unsupported_iterable_to_array$a(arr, i) || _non_iterable_rest$a();
}
function _unsupported_iterable_to_array$a(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$a(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$a(o, minLen);
}
var FormInput = function(props) {
    var hiddenLabel = props.hiddenLabel, containerSx = props.containerSx, label = props.label, helperText = props.helperText, hiddenHelperText = props.hiddenHelperText, belowComponent = props.belowComponent, onClear = props.onClear, filledInputProps = _object_without_properties$8(props, [
        "hiddenLabel",
        "containerSx",
        "label",
        "helperText",
        "hiddenHelperText",
        "belowComponent",
        "onClear"
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        sx: containerSx,
        children: [
            !hiddenLabel && /*#__PURE__*/ jsxs(InputLabel, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                htmlFor: filledInputProps.name,
                children: [
                    label,
                    onClear && /*#__PURE__*/ jsx(IconButton$1, {
                        disableRipple: true,
                        sx: {
                            padding: "6px 0 6px 6px"
                        },
                        onClick: onClear,
                        children: /*#__PURE__*/ jsx(Icon, {
                            component: HighlightOff,
                            sx: {
                                fontSize: 12
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ jsxs(FormControl, {
                size: "small",
                variant: "filled",
                error: filledInputProps.error,
                disabled: filledInputProps.disabled,
                fullWidth: true,
                children: [
                    /*#__PURE__*/ jsx(FilledInput, _object_spread$g({
                        id: filledInputProps.name,
                        size: "small",
                        hiddenLabel: true,
                        disableUnderline: true,
                        fullWidth: true
                    }, filledInputProps)),
                    belowComponent,
                    !hiddenHelperText && /*#__PURE__*/ jsx(FormHelperText, {
                        sx: {
                            margin: "0px"
                        },
                        children: helperText !== null && helperText !== void 0 ? helperText : " "
                    })
                ]
            })
        ]
    });
};
var FormikFormInput = function(props) {
    var name = props.name, onChangeCallback = props.onChangeCallback, isWithClear = props.isWithClear, formInputProps = _object_without_properties$8(props, [
        "name",
        "onChangeCallback",
        "isWithClear"
    ]);
    var _useField = _sliced_to_array$a(useField(name), 3), field = _useField[0], meta = _useField[1], helper = _useField[2];
    var handleChange = function(event) {
        field.onChange(event);
        onChangeCallback === null || onChangeCallback === void 0 ? void 0 : onChangeCallback(event.target.value);
    };
    return /*#__PURE__*/ jsx(FormInput, _object_spread_props$d(_object_spread$g({}, formInputProps), {
        name: name,
        value: field.value,
        onChange: handleChange,
        onBlur: field.onBlur,
        error: meta.touched && Boolean(meta.error),
        helperText: meta.touched ? meta.error : null,
        onClear: isWithClear ? function() {
            return helper.setValue("");
        } : undefined
    }));
};

var ReactPasswordStrengthBar = /*#__PURE__*/ lazy(function() {
    return import('react-password-strength-bar');
});
var StrengthBarPlaceholder = styled(Box)(function() {
    return {
        height: "17px"
    };
});
var PasswordStrengthBar = function(props) {
    var password = props.password, minLength = props.minLength;
    var translationPrefix = "components.common.password.strengthBarScoreWords";
    var t = useTranslation().t;
    var scoreWords = [
        "very weak",
        "weak",
        "okay",
        "good",
        "strong"
    ].map(function(value) {
        return t("".concat(translationPrefix, ".").concat(camelCase(value)), value);
    });
    var theme = useTheme();
    var barColours = [
        "#F3F3F3",
        theme.palette.error.main,
        theme.palette.warning.main,
        theme.palette.info.main,
        theme.palette.primary.main
    ];
    var scoreWordStyle = {
        color: theme.palette.text.secondary,
        fontSize: "8px",
        lineHeight: "8px",
        marginTop: "2px",
        margin: 0
    };
    return /*#__PURE__*/ jsx(Suspense, {
        fallback: /*#__PURE__*/ jsx(StrengthBarPlaceholder, {}),
        children: /*#__PURE__*/ jsx(ReactPasswordStrengthBar, {
            minLength: minLength,
            scoreWords: scoreWords,
            shortScoreWord: t("components.common.password.strengthBarScoreWords.tooShort", "too short"),
            barColors: barColours,
            password: password,
            scoreWordStyle: scoreWordStyle
        })
    });
};

function _array_like_to_array$9(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$9(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$f(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$9(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$9() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$f(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$f(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$c(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$c(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$c(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$7(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$7(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$7(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array$9(arr, i) {
    return _array_with_holes$9(arr) || _iterable_to_array_limit$9(arr, i) || _unsupported_iterable_to_array$9(arr, i) || _non_iterable_rest$9();
}
function _unsupported_iterable_to_array$9(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$9(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$9(o, minLen);
}
var FormPasswordInput = function(props) {
    var withStrengthBar = props.withStrengthBar, minPasswordLength = props.minPasswordLength, formInputProps = _object_without_properties$7(props, [
        "withStrengthBar",
        "minPasswordLength"
    ]);
    var _useState = _sliced_to_array$9(useState(false), 2), showPassword = _useState[0], setShowPassword = _useState[1];
    var handleClickShowPassword = function() {
        return setShowPassword(function(show) {
            return !show;
        });
    };
    var handleMouseDownPassword = function(event) {
        event.preventDefault();
    };
    var renderBelowComponent = function() {
        if (withStrengthBar && minPasswordLength) {
            return /*#__PURE__*/ jsx(PasswordStrengthBar, {
                password: props.value,
                minLength: minPasswordLength
            });
        }
        return undefined;
    };
    return /*#__PURE__*/ jsx(FormInput, _object_spread_props$c(_object_spread$f({}, formInputProps), {
        type: showPassword ? "text" : "password",
        endAdornment: /*#__PURE__*/ jsx(InputAdornment, {
            position: "end",
            children: /*#__PURE__*/ jsx(IconButton$1, {
                "aria-label": "toggle password visibility",
                onClick: handleClickShowPassword,
                onMouseDown: handleMouseDownPassword,
                children: showPassword ? /*#__PURE__*/ jsx(VisibilityOff, {}) : /*#__PURE__*/ jsx(Visibility, {})
            })
        }),
        belowComponent: renderBelowComponent()
    }));
};
var FormikFormPasswordInput = function(props) {
    var name = props.name, onChangeCallback = props.onChangeCallback, formPasswordInputProps = _object_without_properties$7(props, [
        "name",
        "onChangeCallback"
    ]);
    var _useField = _sliced_to_array$9(useField(name), 2), field = _useField[0], meta = _useField[1];
    var handleChange = function(event) {
        field.onChange(event);
        onChangeCallback === null || onChangeCallback === void 0 ? void 0 : onChangeCallback(event.target.value);
    };
    return /*#__PURE__*/ jsx(FormPasswordInput, _object_spread_props$c(_object_spread$f({}, formPasswordInputProps), {
        name: name,
        value: field.value,
        onChange: handleChange,
        onBlur: field.onBlur,
        error: meta.touched && Boolean(meta.error),
        helperText: meta.touched ? meta.error : null
    }));
};

function _array_like_to_array$8(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$8(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$e(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$8(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$8() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$e(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$e(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$b(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$b(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$b(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$6(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$6(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$6(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array$8(arr, i) {
    return _array_with_holes$8(arr) || _iterable_to_array_limit$8(arr, i) || _unsupported_iterable_to_array$8(arr, i) || _non_iterable_rest$8();
}
function _unsupported_iterable_to_array$8(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$8(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$8(o, minLen);
}
var PointerSelect = function(props) {
    var ariaLabel = props.ariaLabel, value = props.value, onChange = props.onChange, items = props.items, rest = _object_without_properties$6(props, [
        "ariaLabel",
        "value",
        "onChange",
        "items"
    ]);
    var renderItems = useMemo(function() {
        return items.map(function(item) {
            return /*#__PURE__*/ jsx(MenuItem, {
                value: item.value,
                children: item.label
            }, item.value);
        });
    }, [
        items
    ]);
    return /*#__PURE__*/ jsx(Select, _object_spread_props$b(_object_spread$e({
        id: props.name,
        "aria-label": ariaLabel,
        disableUnderline: true,
        fullWidth: true
    }, rest), {
        value: value,
        onChange: function(e) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
        },
        children: renderItems
    }));
};
var TouchSelect = function(props) {
    var ariaLabel = props.ariaLabel, value = props.value, onChange = props.onChange, items = props.items, mobileIcon = props.mobileIcon;
    var renderItems = useMemo(function() {
        return items.map(function(item) {
            return /*#__PURE__*/ jsx("option", {
                value: item.value,
                children: item.label
            }, item.value);
        });
    }, [
        items
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        sx: {
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ jsx(NativeSelect, {
                "aria-label": ariaLabel,
                disableUnderline: true,
                sx: {
                    opacity: 0,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%"
                },
                value: value,
                onChange: function(e) {
                    return onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
                },
                children: renderItems
            }),
            mobileIcon
        ]
    });
};
var FormSelect = function(props) {
    var containerSx = props.containerSx, mobileIcon = props.mobileIcon, fullWidth = props.fullWidth, label = props.label, onClear = props.onClear, rest = _object_without_properties$6(props, [
        "containerSx",
        "mobileIcon",
        "fullWidth",
        "label",
        "onClear"
    ]);
    var shouldUseTouchSelect = useMediaQuery(function(theme) {
        return theme.breakpoints.down("sm");
    });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            label ? /*#__PURE__*/ jsxs(InputLabel, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                htmlFor: props.name,
                children: [
                    label,
                    onClear && /*#__PURE__*/ jsx(IconButton$1, {
                        disableRipple: true,
                        sx: {
                            padding: "6px 0 6px 6px"
                        },
                        onClick: onClear,
                        children: /*#__PURE__*/ jsx(Icon, {
                            component: HighlightOff,
                            sx: {
                                fontSize: 12
                            }
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ jsx(FormControl, {
                hiddenLabel: true,
                variant: "filled",
                sx: containerSx,
                fullWidth: fullWidth,
                children: shouldUseTouchSelect && mobileIcon ? /*#__PURE__*/ jsx(TouchSelect, _object_spread$e({
                    mobileIcon: mobileIcon
                }, rest)) : /*#__PURE__*/ jsx(PointerSelect, _object_spread$e({}, rest))
            })
        ]
    });
};
var FormikFormSelect = function(props) {
    var _useField = _sliced_to_array$8(useField(props.name), 3), field = _useField[0], helper = _useField[2];
    return /*#__PURE__*/ jsx(FormSelect, _object_spread_props$b(_object_spread$e({}, props), {
        value: field.value,
        onChange: function(value) {
            return helper.setValue(value);
        },
        onClear: props.isWithClear ? function() {
            return helper.setValue("");
        } : undefined
    }));
};

function Iframe(props) {
    return /*#__PURE__*/ jsx("iframe", {
        src: props.src,
        height: props.height,
        width: props.width,
        title: props.title,
        style: props.style
    });
}

var Container$1 = styled(Box)(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        height: "180px",
        background: theme.palette.common.black,
        borderRadius: "2px",
        overflow: "hidden"
    };
});
var BackgroundImg = styled("div")({
    position: "absolute",
    top: 0,
    left: "calc(70% - 70px)",
    right: 0,
    height: "100%",
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 72px 100%)",
    opacity: "50%",
    "& > img": {
        height: "100%",
        width: "auto",
        position: "absolute",
        right: 0
    }
});
var Content$1 = styled(Stack)({
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    padding: "8px 12px 16px",
    textShadow: "1px 1px 0 #000",
    alignItems: "flex-start",
    justifyContent: "space-between"
});
var Title = styled(Typography)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.common.white,
        fontSize: "10px"
    };
});
var Description = styled(Typography)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.common.white
    };
});
var descriptionSx = {
    big: {
        fontSize: "24px",
        lineHeight: "32px"
    },
    small: {
        fontSize: "16px",
        lineHeight: "21px"
    }
};
var ImageLinkButton = function(param) {
    var buttonText = param.buttonText, description = param.description, img = param.img, onClick = param.onClick, size = param.size, title = param.title;
    return /*#__PURE__*/ jsxs(Container$1, {
        children: [
            /*#__PURE__*/ jsx(BackgroundImg, {
                children: /*#__PURE__*/ jsx("img", {
                    src: img,
                    alt: title,
                    loading: "lazy"
                })
            }),
            /*#__PURE__*/ jsxs(Content$1, {
                children: [
                    /*#__PURE__*/ jsx(Title, {
                        children: title
                    }),
                    /*#__PURE__*/ jsx(Description, {
                        sx: descriptionSx[size],
                        children: description
                    }),
                    /*#__PURE__*/ jsx(Button$1, {
                        onClick: onClick,
                        variant: "contained",
                        color: "secondary",
                        size: "small",
                        startIcon: /*#__PURE__*/ jsx(Icon, {
                            component: WatchTriangle
                        }),
                        children: buttonText
                    })
                ]
            })
        ]
    });
};

function _define_property$d(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$d(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$d(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$a(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$a(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$a(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var Row = styled(Stack)({
    flexDirection: "row",
    gap: "8px",
    "& > *": {
        flexGrow: 1
    }
});
var ImageLinkButtonRow = function(param) {
    var buttons = param.buttons, size = param.size;
    return /*#__PURE__*/ jsx(Row, {
        children: buttons.map(function(button, index) {
            return /*#__PURE__*/ jsx(ImageLinkButton, _object_spread_props$a(_object_spread$d({}, button), {
                size: size
            }), index);
        })
    });
};

function _define_property$c(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$c(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$c(target, key, source[key]);
        });
    }
    return target;
}
var InfoTooltip = function(props) {
    var content = props.content, iconSx = props.iconSx;
    var defaultIconSx = {
        width: "12px",
        height: "12px",
        "&:hover": {
            color: "primary.main"
        }
    };
    return /*#__PURE__*/ jsx(Tooltip, {
        title: content,
        children: /*#__PURE__*/ jsx(Info, {
            sx: iconSx ? _object_spread$c({}, defaultIconSx, iconSx) : defaultIconSx
        })
    });
};

function _define_property$b(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$b(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$b(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$9(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$9(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$9(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var InternalLink = function(props) {
    return /*#__PURE__*/ jsx(Link, _object_spread_props$9(_object_spread$b({
        sx: {
            cursor: "pointer"
        }
    }, props), {
        children: props.children
    }));
};

var StyledLink = styled(InternalLink)(function(param) {
    var theme = param.theme;
    return {
        height: "40px",
        color: theme.palette.text.secondary,
        fontSize: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "none"
    };
});
var LinkButton = function(props) {
    return /*#__PURE__*/ jsx(StyledLink, {
        onClick: props.onClick,
        children: props.children
    });
};

function _define_property$a(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$a(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$a(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$8(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$8(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$8(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$5(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$5(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$5(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var StyledButton$3 = styled$1(Button$1)(function(param) {
    var theme = param.theme;
    return {
        "&.Mui-disabled": {
            color: theme.palette.common.black,
            background: theme.palette.grey[100]
        },
        "&>.MuiButton-startIcon": {
            marginRight: "12px"
        }
    };
});
var Spinner$1 = styled$1(CircularProgress)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.common.black
    };
});
function LoadingButton(_param) {
    var loading = _param.loading, startIcon = _param.startIcon, disabled = _param.disabled, props = _object_without_properties$5(_param, [
        "loading",
        "startIcon",
        "disabled"
    ]);
    return /*#__PURE__*/ jsx(StyledButton$3, _object_spread_props$8(_object_spread$a({}, props), {
        startIcon: loading ? /*#__PURE__*/ jsx(Spinner$1, {
            size: 18,
            thickness: 6
        }) : startIcon,
        disabled: loading || disabled
    }));
}

/**
 * Adds an animation event listener with optional callback. Tidies up after
 * itself.
 * @param animation
 * @param event
 * @param callback
 */ var useAnimationEventListener = function(animation, event, callback) {
    var callbackRef = useRef(callback);
    useEffect(function() {
        if (callback) {
            callbackRef.current = callback;
        }
    }, [
        callback
    ]);
    useEffect(function() {
        var instance = callbackRef.current;
        if (instance && animation) {
            animation.addEventListener(event, instance);
            return function() {
                animation.removeEventListener(event, instance);
            };
        }
        return undefined;
    }, [
        animation,
        event
    ]);
};

function _array_like_to_array$7(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$7(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$7(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$7() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$7(arr, i) {
    return _array_with_holes$7(arr) || _iterable_to_array_limit$7(arr, i) || _unsupported_iterable_to_array$7(arr, i) || _non_iterable_rest$7();
}
function _unsupported_iterable_to_array$7(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$7(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$7(o, minLen);
}
/**
 * Lottie component that renderers Lottie animations
 */ var LottieAnimation = function(param) {
    var animationData = param.animationData, autoplay = param.autoplay, loop = param.loop, style = param.style, onComplete = param.onComplete, onDOMLoaded = param.onDOMLoaded, segments = param.segments;
    var containerRef = useRef(null);
    var _useState = _sliced_to_array$7(useState(), 2), lottieInstance = _useState[0], setLottieInstance = _useState[1];
    var _useState1 = _sliced_to_array$7(useState(), 2), lottieConfig = _useState1[0], setLottieConfig = _useState1[1];
    useEffect(function() {
        var container = containerRef.current;
        if (container) {
            var config = {
                container: container,
                animationData: animationData,
                autoplay: autoplay,
                loop: loop
            };
            setLottieConfig(config);
        }
    }, [
        animationData,
        autoplay,
        loop
    ]);
    useAnimationEventListener(lottieInstance, "complete", onComplete);
    useAnimationEventListener(lottieInstance, "DOMLoaded", onDOMLoaded);
    useEffect(function() {
        var instance;
        if (lottieConfig) {
            instance = Lottie.loadAnimation(lottieConfig);
            setLottieInstance(instance);
        }
        return function() {
            instance === null || instance === void 0 ? void 0 : instance.destroy();
            setLottieInstance(undefined);
        };
    }, [
        lottieConfig
    ]);
    useEffect(function() {
        if (segments) {
            lottieInstance === null || lottieInstance === void 0 ? void 0 : lottieInstance.playSegments(segments);
        }
    }, [
        lottieInstance,
        segments
    ]);
    return /*#__PURE__*/ jsx("div", {
        ref: containerRef,
        style: style
    });
};

var StyledStack$1 = styled(Stack)(function(param) {
    param.theme;
    return {
        padding: "16px 0 8px"
    };
});
var ModalActions = function(param) {
    var children = param.children;
    return /*#__PURE__*/ jsx(StyledStack$1, {
        gap: "8px",
        direction: "row",
        justifyContent: "center",
        children: children
    });
};

function _define_property$9(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$9(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$9(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$7(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$7(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$7(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ModalHeader(props) {
    var title = props.title, titleProps = props.titleProps, subtitle = props.subtitle, subtitleProps = props.subtitleProps, icon = props.icon, containerSx = props.containerSx;
    return /*#__PURE__*/ jsxs(Stack, {
        component: "hgroup",
        sx: _object_spread$9({
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center"
        }, containerSx),
        children: [
            /*#__PURE__*/ jsx(Box, {
                sx: function(theme) {
                    return {
                        marginTop: "16px",
                        color: theme.palette.text.secondary
                    };
                },
                children: icon
            }),
            typeof title === "string" ? /*#__PURE__*/ jsx(Typography, _object_spread_props$7(_object_spread$9({
                variant: "h5"
            }, titleProps), {
                sx: _object_spread$9({
                    marginTop: "16px",
                    marginBottom: "4px"
                }, titleProps === null || titleProps === void 0 ? void 0 : titleProps.sx),
                children: title
            })) : title,
            typeof subtitle === "string" ? /*#__PURE__*/ jsx(Typography, _object_spread_props$7(_object_spread$9({
                variant: "h6"
            }, subtitleProps), {
                children: subtitle
            })) : subtitle
        ]
    });
}

function ModalContent(param) {
    var children = param.children;
    return /*#__PURE__*/ jsx(Box, {
        sx: {
            padding: "8px 0 8px 0",
            flexGrow: 1,
            width: "100%"
        },
        children: children
    });
}

function _define_property$8(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$8(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$8(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$6(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ModalTextBox = function(props) {
    var title = props.title, titleProps = props.titleProps, body = props.body, bodyProps = props.bodyProps;
    return /*#__PURE__*/ jsxs(Stack, {
        sx: {
            padding: "20px",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            minHeight: "200px",
            border: "1px solid",
            borderColor: "#E5E5E5"
        },
        children: [
            /*#__PURE__*/ jsx(Typography, _object_spread_props$6(_object_spread$8({
                variant: "h3",
                sx: {
                    fontSize: "14px",
                    lineHeight: "18px",
                    marginBottom: "12px"
                }
            }, titleProps), {
                children: title
            })),
            body ? /*#__PURE__*/ jsx(Typography, _object_spread_props$6(_object_spread$8({
                variant: "body2"
            }, bodyProps), {
                children: body
            })) : null
        ]
    });
};

function _define_property$7(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$7(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ModalButton = function(props) {
    var children = props.children;
    return /*#__PURE__*/ jsx(Button$1, _object_spread_props$5(_object_spread$7({
        variant: "modal"
    }, props), {
        children: children
    }));
};

var ModalAlert = function(param) {
    var title = param.title, subtitle = param.subtitle, header = param.header, body = param.body, onBackClick = param.onBackClick;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(ModalHeader, {
                icon: /*#__PURE__*/ jsx(Icon, {
                    component: RecastR,
                    sx: {
                        fontSize: "96px",
                        marginBottom: "24px",
                        color: "common.black"
                    }
                }),
                title: title,
                subtitle: subtitle
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsx(ModalTextBox, {
                    title: header,
                    body: body
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(ModalButton, {
                    onClick: onBackClick,
                    children: t("common.back", "Back")
                })
            })
        ]
    });
};

var ModalUnsupportedRegion = function(param) {
    var subtitle = param.subtitle, supportedRegionsUrl = param.supportedRegionsUrl, onSupportedRegionsClick = param.onSupportedRegionsClick, onBackClick = param.onBackClick;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(ModalAlert, {
        title: t("components.modalUnsupportedRegion.title", "Oh no!"),
        subtitle: subtitle,
        header: t("components.modalUnsupportedRegion.bodyTitle", "Unfortunately it looks like you’re trying to access Recast in a region we haven’t launched in yet."),
        body: /*#__PURE__*/ jsx(Trans, {
            i18nKey: "components.modalUnsupportedRegion.body",
            defaults: "Recast is available in 90+ countries and territories and we’re expanding our global coverage all the time. Visit our <WebsiteLink>website</WebsiteLink> to find out where Recast is currently available.",
            components: {
                WebsiteLink: /*#__PURE__*/ jsx(ExternalLink, {
                    onClick: onSupportedRegionsClick,
                    href: supportedRegionsUrl
                })
            }
        }),
        onBackClick: onBackClick
    });
};

function _define_property$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$6(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$4(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$4(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$4(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var StyledModalWrapper = styled(Modal$1)(function() {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };
});
var ModalWrapper = function(_param) {
    var children = _param.children, props = _object_without_properties$4(_param, [
        "children"
    ]);
    return /*#__PURE__*/ jsx(StyledModalWrapper, _object_spread_props$4(_object_spread$6({}, props), {
        children: children
    }));
};

var StyledStack = styled(Stack)(function(param) {
    var theme = param.theme;
    return {
        maxWidth: "400px",
        borderRadius: "3px",
        padding: "16px",
        marginLeft: "auto",
        marginRight: "auto",
        "&.light": {
            background: theme.palette.common.white,
            color: theme.palette.common.black
        },
        "&.dark": {
            background: theme.palette.common.black,
            color: theme.palette.common.white,
            boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.5)"
        }
    };
});
var Modal = function(param) {
    var children = param.children, _param_variant = param.variant, variant = _param_variant === void 0 ? "dark" : _param_variant, sx = param.sx;
    return /*#__PURE__*/ jsx(StyledStack, {
        className: variant,
        alignItems: "center",
        sx: sx,
        children: children
    });
};

function NotificationModal(param) {
    var description = param.description, onClose = param.onClose, title = param.title, icon = param.icon, confirmLabel = param.confirmLabel, onConfirm = param.onConfirm, customButtons = param.customButtons;
    return /*#__PURE__*/ jsxs(Modal, {
        variant: "light",
        sx: {
            alignItems: "flex-start",
            position: "relative",
            padding: "58px 32px 36px"
        },
        children: [
            /*#__PURE__*/ jsx(IconButton$1, {
                onClick: onClose,
                sx: {
                    position: "absolute",
                    right: "20px",
                    top: "20px"
                },
                children: /*#__PURE__*/ jsx(Icon, {
                    component: Close,
                    sx: function(theme) {
                        return {
                            color: theme.palette.common.black
                        };
                    }
                })
            }),
            icon && /*#__PURE__*/ jsx(Icon, {
                component: icon,
                sx: function(theme) {
                    return {
                        fontSize: "64px",
                        color: theme.palette.common.black
                    };
                }
            }),
            /*#__PURE__*/ jsx(Typography, {
                variant: "h3",
                sx: {
                    marginTop: "20px"
                },
                children: title
            }),
            /*#__PURE__*/ jsx(Typography, {
                variant: "body1",
                sx: {
                    marginTop: "8px",
                    a: {
                        color: Colors.GrayDark,
                        ":visited": {
                            color: Colors.GrayDark
                        },
                        ":hover": {
                            color: Colors.DarkTeal
                        },
                        textDecoration: "none"
                    }
                },
                children: description
            }),
            customButtons ? customButtons : /*#__PURE__*/ jsx(Button$1, {
                onClick: onConfirm,
                sx: {
                    marginTop: "32px"
                },
                children: confirmLabel
            })
        ]
    });
}

function LiveEventEndedModal(param) {
    var channelName = param.channelName, onClose = param.onClose, onConfirm = param.onConfirm;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(NotificationModal, {
        icon: Warning,
        title: t("components.common.liveEventEndedModal.title", "This content is no longer available"),
        description: /*#__PURE__*/ jsx(Typography, {
            variant: "body1",
            children: t("components.common.liveEventEndedModal.headBackToTheChannel", "Head back to the {{channel}}'s channel for more great videos.", {
                channel: channelName
            })
        }),
        confirmLabel: t("components.common.liveEventEndedModal.close", "Close"),
        onConfirm: onConfirm,
        onClose: onClose
    });
}

function ReplayIsProcessingModal(param) {
    var channelName = param.channelName, onConfirm = param.onConfirm, onClose = param.onClose;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(NotificationModal, {
        icon: Cog,
        title: t("components.common.replayIsProcessingModal.title", "The Live stream has ended"),
        description: /*#__PURE__*/ jsxs(Stack, {
            gap: "20px",
            children: [
                /*#__PURE__*/ jsx(Typography, {
                    variant: "body1",
                    children: t("components.common.replayIsProcessingModal.replayAvailableSoon", "...but the Replay will be available soon!")
                }),
                /*#__PURE__*/ jsx(Typography, {
                    variant: "body1",
                    children: t("components.common.replayIsProcessingModal.checkOutChannel", "Meanwhile check out {{channel}}'s channel for more great videos", {
                        channel: channelName
                    })
                })
            ]
        }),
        confirmLabel: t("components.purchase.liveEventReplayProcessing.letsGo", "Let's go"),
        onConfirm: onConfirm,
        onClose: onClose
    });
}

var ContainerBox = styled(Box)(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        border: "1px solid",
        borderRadius: "2px",
        borderColor: theme.palette.grey[200],
        padding: "2px",
        maxWidth: "120px",
        minHeight: "88px",
        cursor: "pointer",
        "&.disabled": {
            cursor: "default"
        },
        "&.selected": {
            borderColor: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.2)
        }
    };
});
var DisabledOverlay = styled(Box)(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: theme.palette.grey[200],
        opacity: 0.75
    };
});
var QuickCastButton = function(param) {
    var _param_packag = param.packag, units = _param_packag.units, bonus = _param_packag.bonus, paymentConfig = param.paymentConfig, disabled = param.disabled, onClick = param.onClick, selected = param.selected, sx = param.sx;
    return /*#__PURE__*/ jsx(ContainerBox, {
        sx: sx,
        onClick: disabled ? undefined : onClick,
        className: "".concat(disabled ? "disabled" : "", " ").concat(selected ? "selected" : ""),
        children: /*#__PURE__*/ jsxs(Stack, {
            alignItems: "center",
            children: [
                /*#__PURE__*/ jsx(Typography, {
                    sx: {
                        fontSize: "11px",
                        fontWeight: 300
                    },
                    children: /*#__PURE__*/ jsx(CastAmount, {
                        amount: units,
                        strikeThrough: true
                    })
                }),
                /*#__PURE__*/ jsx(Typography, {
                    sx: {
                        fontSize: "22px",
                        fontWeight: 600
                    },
                    children: /*#__PURE__*/ jsx(CastAmount, {
                        amount: units + bonus
                    })
                }),
                /*#__PURE__*/ jsxs(Typography, {
                    sx: {
                        fontSize: "9px",
                        fontWeight: 600,
                        color: Colors.Blue,
                        marginTop: "3px"
                    },
                    children: [
                        Math.floor(bonus / units * 100),
                        "% EXTRA"
                    ]
                }),
                /*#__PURE__*/ jsx(Typography, {
                    sx: {
                        fontSize: "14px",
                        fontWeight: 600
                    },
                    children: castsToCurrencyString(units, paymentConfig)
                }),
                disabled && /*#__PURE__*/ jsx(DisabledOverlay, {})
            ]
        })
    });
};

function _array_like_to_array$6(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$6(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array$6(arr);
}
function _define_property$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit$6(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$6() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$5(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$3(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$3(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$3(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$3(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array$6(arr, i) {
    return _array_with_holes$6(arr) || _iterable_to_array_limit$6(arr, i) || _unsupported_iterable_to_array$6(arr, i) || _non_iterable_rest$6();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array$6(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array$6(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$6(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$6(o, minLen);
}
var QuickCastSelect = function(param) {
    var paymentConfig = param.paymentConfig, value = param.value, sx = param.sx, onChange = param.onChange, limit = param.limit;
    var lastSelectedUnitsRef = useRef();
    if (lastSelectedUnitsRef.current !== value) {
        lastSelectedUnitsRef.current = undefined;
    }
    var sortedPackages = _to_consumable_array(paymentConfig.packages).sort(function(a, b) {
        return a.units - b.units;
    });
    var packages = limit ? sortedPackages.slice(0, limit) : sortedPackages;
    return /*#__PURE__*/ jsx(Stack, {
        direction: "row",
        gap: "4px",
        sx: sx,
        children: packages.map(function(packag) {
            return /*#__PURE__*/ jsx(QuickCastButton, {
                sx: {
                    flexGrow: 1
                },
                packag: packag,
                paymentConfig: paymentConfig,
                selected: lastSelectedUnitsRef.current === packag.units,
                onClick: function() {
                    lastSelectedUnitsRef.current = packag.units;
                    onChange(packag.units);
                }
            }, packag.units);
        })
    });
};
var FormikQuickCastSelect = function(_param) {
    var name = _param.name, props = _object_without_properties$3(_param, [
        "name"
    ]);
    var _useField = _sliced_to_array$6(useField(name), 3), field = _useField[0], helpers = _useField[2];
    return /*#__PURE__*/ jsx(QuickCastSelect, _object_spread_props$3(_object_spread$5({}, props), {
        value: field.value,
        onChange: function(value) {
            helpers.setTouched(true);
            helpers.setValue(value);
        }
    }));
};

var spinnerAnimation = {
    v: "5.6.5",
    fr: 60,
    ip: 0,
    op: 24,
    w: 100,
    h: 100,
    nm: "Flower",
    ddd: 0,
    assets: [],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "Shape Layer 13",
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 18,
                            s: [
                                100
                            ]
                        },
                        {
                            t: 24.999609375,
                            s: [
                                70
                            ]
                        }
                    ],
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 324,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        99.375,
                        57.75,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        27.014,
                        31.134,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        67.975,
                        67.975,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -49,
                                            -49.75
                                        ],
                                        [
                                            -25.25,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -24
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    0,
                                    0.909803926945,
                                    0.815686285496,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 30,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    29.894,
                                    32.654
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 18,
            op: 25,
            st: 14.4,
            bm: 0
        },
        {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: "Shape Layer 12",
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 16,
                            s: [
                                30
                            ]
                        },
                        {
                            t: 22.999609375,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 288,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        95.625,
                        28.25,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        27.014,
                        31.134,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        67.975,
                        67.975,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -49,
                                            -49.75
                                        ],
                                        [
                                            -25.25,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -24
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    0,
                                    0.909803926945,
                                    0.815686285496,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    29.894,
                                    32.654
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 16,
            op: 23,
            st: 12.4,
            bm: 0
        },
        {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "Shape Layer 11",
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 14,
                            s: [
                                30
                            ]
                        },
                        {
                            t: 20.999609375,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 252,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        75.375,
                        6.75,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        27.014,
                        31.134,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        67.975,
                        67.975,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -49,
                                            -49.75
                                        ],
                                        [
                                            -25.25,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -24
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    0,
                                    0.909803926945,
                                    0.815686285496,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    29.894,
                                    32.654
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 14,
            op: 21,
            st: 10.4,
            bm: 0
        },
        {
            ddd: 0,
            ind: 4,
            ty: 4,
            nm: "Shape Layer 10",
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 12,
                            s: [
                                30
                            ]
                        },
                        {
                            t: 18.999609375,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 216,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        46.375,
                        1.5,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        27.014,
                        31.134,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        67.975,
                        67.975,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -49,
                                            -49.75
                                        ],
                                        [
                                            -25.25,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -24
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    0,
                                    0.909803926945,
                                    0.815686285496,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    29.894,
                                    32.654
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 12,
            op: 19,
            st: 8.4,
            bm: 0
        },
        {
            ddd: 0,
            ind: 5,
            ty: 4,
            nm: "Shape Layer 8",
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 10,
                            s: [
                                30
                            ]
                        },
                        {
                            t: 16.999609375,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 180,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        19.625,
                        14.25,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        27.014,
                        31.134,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        67.975,
                        67.975,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -49,
                                            -49.75
                                        ],
                                        [
                                            -25.25,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -24
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    0,
                                    0.909803926945,
                                    0.815686285496,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    29.894,
                                    32.654
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 10,
            op: 17,
            st: 6.4,
            bm: 0
        },
        {
            ddd: 0,
            ind: 6,
            ty: 4,
            nm: "Shape Layer 7",
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 8,
                            s: [
                                30
                            ]
                        },
                        {
                            t: 14.999609375,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 144,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        5.125,
                        41,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        27.014,
                        31.134,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        67.975,
                        67.975,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -49,
                                            -49.75
                                        ],
                                        [
                                            -25.25,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -24
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    0,
                                    0.909803926945,
                                    0.815686285496,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    29.894,
                                    32.654
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 8,
            op: 15,
            st: 4.4,
            bm: 0
        },
        {
            ddd: 0,
            ind: 7,
            ty: 4,
            nm: "Shape Layer 6",
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 6,
                            s: [
                                30
                            ]
                        },
                        {
                            t: 12.999609375,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 108,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        10.125,
                        70.25,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        27.014,
                        31.134,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        67.975,
                        67.975,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -49,
                                            -49.75
                                        ],
                                        [
                                            -25.25,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -24
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    0,
                                    0.909803926945,
                                    0.815686285496,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    29.894,
                                    32.654
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 6,
            op: 13,
            st: 2.4,
            bm: 0
        },
        {
            ddd: 0,
            ind: 8,
            ty: 4,
            nm: "Shape Layer 5",
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 4,
                            s: [
                                30
                            ]
                        },
                        {
                            t: 10.999609375,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 72,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        30.375,
                        92.25,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        27.014,
                        31.134,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        67.975,
                        67.975,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -49,
                                            -49.75
                                        ],
                                        [
                                            -25.25,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -24
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    0,
                                    0.909803926945,
                                    0.815686285496,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    29.894,
                                    32.654
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 4,
            op: 11,
            st: 0.4,
            bm: 0
        },
        {
            ddd: 0,
            ind: 9,
            ty: 4,
            nm: "Shape Layer 4",
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 2,
                            s: [
                                30
                            ]
                        },
                        {
                            t: 8.999609375,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 36,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        59.375,
                        98,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        27.014,
                        31.134,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        67.975,
                        67.975,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -49,
                                            -49.75
                                        ],
                                        [
                                            -25.25,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -24
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    0,
                                    0.909803926945,
                                    0.815686285496,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    29.894,
                                    32.654
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 2,
            op: 9,
            st: -1.6,
            bm: 0
        },
        {
            ddd: 0,
            ind: 10,
            ty: 4,
            nm: "Shape Layer 3",
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 0,
                            s: [
                                100
                            ]
                        },
                        {
                            t: 23.999609375,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        85.875,
                        84.5,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        27.014,
                        31.134,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        67.975,
                        67.975,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -49,
                                            -49.75
                                        ],
                                        [
                                            -25.25,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -1.75
                                        ],
                                        [
                                            -3,
                                            -24
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    0,
                                    0.909803926945,
                                    0.815686285496,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    29.894,
                                    32.654
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 0,
            op: 24,
            st: -20.6,
            bm: 0
        },
        {
            ddd: 0,
            ind: 11,
            ty: 4,
            nm: "Shape Layer 14",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 10,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        58.875,
                        56.25,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        0,
                        0,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        16,
                        16,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            1.744
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.744,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -1.746
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.75,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            1.784
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.369,
                                            1.369
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.936,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -1.784
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.752,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -1.744
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.746,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.744,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -1.744
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.746,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            1.784
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.752,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -1.936
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.369,
                                            -1.369
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.75,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            1.782
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.744,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            1.746
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -176.009,
                                            179.471
                                        ],
                                        [
                                            -73.285,
                                            179.471
                                        ],
                                        [
                                            -70.114,
                                            176.3
                                        ],
                                        [
                                            -70.114,
                                            -75.105
                                        ],
                                        [
                                            -66.943,
                                            -78.276
                                        ],
                                        [
                                            80.451,
                                            -78.276
                                        ],
                                        [
                                            83.626,
                                            -75.102
                                        ],
                                        [
                                            83.626,
                                            -25.41
                                        ],
                                        [
                                            86.795,
                                            -22.239
                                        ],
                                        [
                                            176.011,
                                            -22.239
                                        ],
                                        [
                                            179.183,
                                            -25.41
                                        ],
                                        [
                                            179.183,
                                            -83.779
                                        ],
                                        [
                                            177.044,
                                            -88.941
                                        ],
                                        [
                                            88.653,
                                            -177.333
                                        ],
                                        [
                                            83.49,
                                            -179.471
                                        ],
                                        [
                                            -83.073,
                                            -179.471
                                        ],
                                        [
                                            -86.244,
                                            -176.3
                                        ],
                                        [
                                            -86.244,
                                            -89.147
                                        ],
                                        [
                                            -89.415,
                                            -85.976
                                        ],
                                        [
                                            -176.011,
                                            -85.976
                                        ],
                                        [
                                            -179.182,
                                            -82.805
                                        ],
                                        [
                                            -179.182,
                                            176.297
                                        ],
                                        [
                                            -176.009,
                                            179.471
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "fl",
                            c: {
                                a: 0,
                                k: [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                ix: 4
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 0,
            op: 1820,
            st: 0,
            bm: 0
        }
    ],
    markers: []
};

var StyledRecastSpinner = styled("div")(function(param) {
    param.theme;
    return {
        pointerEvents: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%"
    };
});
var RecastLogoSpinner = function() {
    return /*#__PURE__*/ jsx(StyledRecastSpinner, {
        children: /*#__PURE__*/ jsx(LottieAnimation, {
            animationData: spinnerAnimation,
            autoplay: true,
            loop: true
        })
    });
};

function _define_property$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$4(target, key, source[key]);
        });
    }
    return target;
}
var RecastWidgetBranding = function(props) {
    var darkTextColor = props.darkTextColor, lightTextColor = props.lightTextColor, bgColor = props.bgColor, containerSx = props.containerSx;
    var t = useTranslation().t;
    var textColor = getDynamicColorFromBg({
        darkColor: darkTextColor,
        lightColor: lightTextColor,
        bgColor: bgColor
    });
    return /*#__PURE__*/ jsxs(Box, {
        sx: _object_spread$4({
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "6px"
        }, containerSx),
        children: [
            /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                sx: {
                    color: textColor,
                    lineHeight: "10px",
                    transform: "translateY(1px)"
                },
                children: t("components.widget.branding.poweredBy", "Powered by")
            }),
            /*#__PURE__*/ jsx(Icon, {
                component: RecastR,
                sx: {
                    color: "primary.main",
                    fontSize: 14
                }
            }),
            /*#__PURE__*/ jsx(Icon, {
                component: RecastText,
                sx: {
                    color: textColor,
                    height: 10,
                    fontSize: 34
                }
            })
        ]
    });
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var MAX_LENGTH = 15;
var MIN_LENGTH = 3;
var StyledBox$2 = styled$1(Box)(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "337px",
        minWidth: "347px",
        maxWidth: "397px",
        borderRadius: "3px",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "32px 30px 15px 30px",
        outline: "none",
        backgroundColor: theme.palette.common.white
    };
});
var StyledTypography = styled$1(Typography)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.text.primary,
        textAlign: "center",
        marginBottom: "5px",
        maxWidth: "325px"
    };
});
var StyledForm = styled$1(Form)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%"
});
var StyledModal = styled$1(Modal$1)({
    position: "absolute",
    height: "100%",
    "& .MuiBackdrop-root": {
        position: "relative",
        height: "100%"
    }
});
function SetUsername(param) {
    var username = param.username, prompt = param.prompt, onSubmit = param.onSubmit;
    var onFormSubmit = function() {
        var _ref = _async_to_generator(function(param, param1) {
            var username, setFieldError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        username = param.username, setFieldError = param1.setFieldError;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            onSubmit(username)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _state.sent();
                        setFieldError("username", "username is taken");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFormSubmit(_, _1) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ jsx(StyledModal, {
        open: true,
        disablePortal: true,
        children: /*#__PURE__*/ jsxs(StyledBox$2, {
            children: [
                /*#__PURE__*/ jsx(Icon, {
                    component: Profile,
                    sx: function(theme) {
                        return {
                            width: "92px",
                            height: "92px",
                            marginBottom: "24px",
                            color: theme.palette.text.primary
                        };
                    }
                }),
                /*#__PURE__*/ jsx(StyledTypography, {
                    variant: "body1",
                    children: prompt
                }),
                /*#__PURE__*/ jsx(Formik, {
                    validateOnMount: true,
                    validateOnChange: true,
                    initialValues: {
                        username: trim(username)
                    },
                    onSubmit: onFormSubmit,
                    initialTouched: {
                        username: true
                    },
                    validate: function(param) {
                        var username = param.username;
                        var errors = {};
                        if (username.length < MIN_LENGTH || username.length > MAX_LENGTH) {
                            errors.username = "username must be between ".concat(MIN_LENGTH, " and ").concat(MAX_LENGTH, " characters");
                        }
                        return errors;
                    },
                    children: function(param)  {
                        var values = param.values, errors = param.errors, isSubmitting = param.isSubmitting, handleChange = param.handleChange;
                        var _errors_username;
                        return jsxs(StyledForm, {
                            children: [
                                /*#__PURE__*/ jsx(TextField, {
                                    name: "username",
                                    value: values.username,
                                    error: !!errors.username,
                                    helperText: (_errors_username = errors.username) !== null && _errors_username !== void 0 ? _errors_username : "great choice!",
                                    onChange: handleChange,
                                    sx: function(theme) {
                                        return {
                                            "& .MuiInputBase-input": {
                                                textAlign: "center",
                                                color: theme.palette.common.black
                                            },
                                            "& .MuiFormHelperText-root": {
                                                textAlign: "center"
                                            }
                                        };
                                    }
                                }),
                                /*#__PURE__*/ jsx(Button$1, {
                                    type: "submit",
                                    sx: {
                                        width: "198px"
                                    },
                                    disabled: isSubmitting || !!errors.username,
                                    children: "Confirm"
                                })
                            ]
                        });
                    }
                })
            ]
        })
    });
}

function _array_like_to_array$5(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$5(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$5(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$5() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$5(arr, i) {
    return _array_with_holes$5(arr) || _iterable_to_array_limit$5(arr, i) || _unsupported_iterable_to_array$5(arr, i) || _non_iterable_rest$5();
}
function _unsupported_iterable_to_array$5(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$5(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$5(o, minLen);
}
var StyledDiv$1 = styled("div")(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: theme.palette.common.white,
        width: "auto",
        borderRadius: "2px",
        color: theme.palette.common.black,
        height: "32px",
        cursor: "pointer",
        userSelect: "none"
    };
});
var StyledMenu$1 = styled(MenuList)({
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    borderRadius: "3px",
    padding: "7px 0"
});
var StyledMenuItem$1 = styled(MenuItem)(function(param) {
    var theme = param.theme;
    return {
        padding: "0 0 0 7px",
        minHeight: "24px",
        color: theme.palette.common.black,
        "&:hover": {
            color: theme.palette.primary.main,
            backgroundColor: "transparent",
            "& .MuiTypography-root": {
                color: theme.palette.primary.main
            }
        }
    };
});
var renderOptions$1 = function(options, handleTooltipClose) {
    return /*#__PURE__*/ jsx(StyledMenu$1, {
        children: options.map(function(param, i) {
            var onClick = param.onClick, text = param.text, icon = param.icon;
            return /*#__PURE__*/ jsxs(StyledMenuItem$1, {
                onClick: function() {
                    onClick();
                    handleTooltipClose();
                },
                disableRipple: true,
                disableTouchRipple: true,
                children: [
                    /*#__PURE__*/ jsx(Icon, {
                        sx: {
                            marginRight: "10px",
                            fontSize: "15px"
                        },
                        component: icon
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        sx: function(theme) {
                            return {
                                fontSize: "11px",
                                fontWeight: 400,
                                lineHeight: "16px",
                                color: theme.palette.common.black
                            };
                        },
                        children: text
                    })
                ]
            }, "option-".concat(i));
        })
    });
};
var SignupButton = function(param) {
    var options = param.options, onClick = param.onClick;
    var _useState = _sliced_to_array$5(useState(false), 2), isTooltipOpen = _useState[0], setIsTooltipOpen = _useState[1];
    var t = useTranslation().t;
    var handleTooltipClose = function() {
        return setIsTooltipOpen(false);
    };
    return /*#__PURE__*/ jsx(ClickAwayListener, {
        onClickAway: handleTooltipClose,
        children: /*#__PURE__*/ jsx("div", {
            children: /*#__PURE__*/ jsx(Tooltip$1, {
                componentsProps: {
                    tooltip: {
                        sx: {
                            background: "white",
                            padding: "0px",
                            maxWidth: "none"
                        }
                    },
                    arrow: {
                        sx: {
                            color: "white"
                        }
                    }
                },
                arrow: true,
                title: renderOptions$1(options, handleTooltipClose),
                PopperProps: {
                    disablePortal: true,
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [
                                    0,
                                    -11
                                ]
                            }
                        },
                        {
                            name: "sameWidth",
                            enabled: true,
                            fn: function(param) {
                                var state = param.state;
                                state.styles["popper"].width = "".concat(state.rects.reference.width, "px");
                            },
                            phase: "beforeWrite",
                            requires: [
                                "computeStyles"
                            ]
                        },
                        {
                            name: "arrow",
                            enabled: true,
                            fn: function(param) {
                                var state = param.state;
                                state.styles["arrow"].right = "0";
                                state.styles["arrow"].transform = "translate(-8px, 0)";
                            },
                            phase: "beforeWrite",
                            requires: [
                                "computeStyles"
                            ]
                        }
                    ]
                },
                open: isTooltipOpen,
                onClose: handleTooltipClose,
                enterDelay: 200,
                disableFocusListener: true,
                disableHoverListener: true,
                disableTouchListener: true,
                children: /*#__PURE__*/ jsxs(StyledDiv$1, {
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ jsx(Icon, {
                            sx: function(theme) {
                                return {
                                    height: "18px",
                                    width: "18px",
                                    margin: "7px",
                                    color: theme.palette.primary.main
                                };
                            },
                            component: RecastR
                        }),
                        /*#__PURE__*/ jsx(Typography, {
                            sx: function(theme) {
                                return {
                                    fontWeight: 500,
                                    fontSize: "12px",
                                    lineHeight: "1.5",
                                    marginRight: "25px",
                                    color: theme.palette.common.black
                                };
                            },
                            children: t("components.signup.join", "Join")
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            sx: function(theme) {
                                return {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "32px",
                                    width: "32px",
                                    borderLeft: "1px solid ".concat(theme.palette.primary.main)
                                };
                            },
                            onClick: function(e) {
                                e.stopPropagation();
                                setIsTooltipOpen(!isTooltipOpen);
                            },
                            children: /*#__PURE__*/ jsx(Icon, {
                                component: ThreeDotsVertical,
                                sx: {
                                    height: "10px"
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
};

function _array_like_to_array$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$4(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$4(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$4() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$4(arr, i) {
    return _array_with_holes$4(arr) || _iterable_to_array_limit$4(arr, i) || _unsupported_iterable_to_array$4(arr, i) || _non_iterable_rest$4();
}
function _unsupported_iterable_to_array$4(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$4(o, minLen);
}
var SliderItem = styled$1(Box$1, {
    shouldForwardProp: function(prop) {
        return prop !== "active";
    }
})(function(param) {
    var active = param.active;
    return {
        position: active ? "relative" : "absolute",
        opacity: active ? 1 : 0,
        transition: "500ms",
        top: 0,
        pointerEvents: active ? "unset" : "none"
    };
});
var SliderButton = styled$1("button", {
    shouldForwardProp: function(prop) {
        return prop !== "active";
    }
})(function(param) {
    var theme = param.theme, active = param.active;
    return {
        width: "16px",
        height: "16px",
        border: "none",
        borderRadius: "2px",
        transition: "500ms",
        cursor: "pointer",
        backgroundColor: active ? theme.palette.primary.main : "#444"
    };
});
function Slider(param) {
    var items = param.items, render = param.render, autoplaySeconds = param.autoplaySeconds;
    var _useState = _sliced_to_array$4(useState(0), 2), currentIndex = _useState[0], setCurrentIndex = _useState[1];
    useEffect(function() {
        if (autoplaySeconds && items.length) {
            var timeout = setTimeout(function() {
                return setCurrentIndex(function(index) {
                    return (index + 1) % items.length;
                });
            }, autoplaySeconds * 1000);
            return function() {
                clearTimeout(timeout);
            };
        }
        return;
    }, [
        autoplaySeconds,
        currentIndex,
        items.length
    ]);
    return /*#__PURE__*/ jsxs(Stack$1, {
        position: "relative",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        marginBottom: "24px",
        children: [
            /*#__PURE__*/ jsx(Box$1, {
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ jsx(SliderItem, {
                        active: index === currentIndex,
                        children: render(item)
                    }, index);
                })
            }),
            /*#__PURE__*/ jsx(Stack$1, {
                flexDirection: "row",
                gap: "8px",
                children: items.map(function(_, index) {
                    return /*#__PURE__*/ jsx(SliderButton, {
                        title: "select slider item ".concat(index + 1),
                        active: index === currentIndex,
                        type: "button",
                        onClick: function() {
                            return setCurrentIndex(index);
                        }
                    }, index);
                })
            })
        ]
    });
}

function _define_property$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$3(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$2(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var SocialLoginButton = function(_param) {
    var socialLoginType = _param.socialLoginType, props = _object_without_properties$2(_param, [
        "socialLoginType"
    ]);
    var children = props.children;
    var startIcon = socialLoginType === "facebook" ? /*#__PURE__*/ jsx(Facebook, {
        sx: {
            width: "26px",
            height: "26px",
            color: "#4267B2"
        }
    }) : /*#__PURE__*/ jsx(Icon, {
        sx: {
            width: "22px",
            height: "22px"
        },
        component: Google
    });
    return /*#__PURE__*/ jsx(Button$1, _object_spread_props$2(_object_spread$3({
        variant: "socialLogin",
        startIcon: startIcon,
        sx: {
            whiteSpace: "nowrap"
        }
    }, props), {
        children: children
    }));
};

function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var darkPalette /*: Palette */  = {
    background: {
        default: Colors.RecastBlack
    },
    primary: {
        main: Colors.Primary,
        dark: Colors.PrimaryDark
    },
    secondary: {
        main: Colors.Blue
    },
    text: {
        primary: Colors.White,
        secondary: Colors.DescriptionGray
    },
    error: {
        main: Colors.Error
    },
    warning: {
        main: Colors.Warning
    },
    info: {
        main: Colors.Info
    },
    success: {
        main: Colors.Success
    },
    common: {
        black: Colors.RecastBlack,
        white: Colors.White
    },
    grey: {
        "400": Colors.GrayLight,
        "500": Colors.Gray,
        "600": Colors.GrayDark,
        "700": Colors.GrayDark2,
        "800": Colors.GrayDark3,
        "900": Colors.GrayDark4
    },
    live: {
        light: Colors.LiveHighlight100,
        main: Colors.LiveHighlight400,
        dark: Colors.LiveHighlight700,
        contrastText: Colors.RecastBlack
    },
    social: {
        main: Colors.SocialButtonBorder
    }
};
var lightPalette = _object_spread_props$1(_object_spread$2({}, darkPalette), {
    background: {
        default: Colors.White
    },
    text: {
        primary: Colors.RecastBlack,
        secondary: Colors.DescriptionGray
    }
});
var typography = {
    fontFamily: [
        "Recast Sans",
        "Poppins",
        "Helvetica",
        "Arial",
        "sans-serif"
    ].join(","),
    fontSize: 14,
    overline: {
        fontSize: "12px",
        lineHeight: "12px",
        transform: "uppercase"
    },
    caption: {
        fontSize: "12px",
        lineHeight: "20px"
    },
    body1: {
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: 300
    },
    body2: {
        fontSize: "10px",
        lineHeight: "14px",
        fontWeight: 300
    },
    subtitle1: {
        fontSize: "18px",
        lineHeight: "24px"
    },
    subtitle2: {
        fontSize: "14px",
        lineHeight: "18px"
    },
    h6: {
        fontSize: "12px",
        lineHeight: "16px"
    },
    h5: {
        fontSize: "18px",
        lineHeight: "21px",
        fontWeight: 600
    },
    h4: {
        fontSize: "21px",
        lineHeight: "24px"
    },
    h3: {
        fontSize: "24px",
        lineHeight: "28px",
        fontWeight: 600
    },
    h2: {
        fontSize: "44px",
        lineHeight: "48px",
        fontWeight: 600
    },
    h1: {
        fontSize: "56px",
        lineHeight: "64px",
        fontWeight: 600
    }
};
var components = {
    MuiAvatar: {
        defaultProps: {
            variant: "square"
        },
        styleOverrides: {
            root: {
                fontSize: 11,
                fontWeight: 600,
                height: 24,
                width: 24
            }
        }
    },
    MuiListItem: {
        defaultProps: {
            alignItems: "flex-start"
        },
        styleOverrides: {
            root: {
                borderRadius: "4px",
                backgroundColor: Colors.GrayDark4,
                padding: "12px 13px 11px 10px",
                maxWidth: "402px",
                "& .MuiListItemSecondaryAction-root": {
                    transform: "none",
                    top: "auto",
                    right: "auto",
                    left: "0px",
                    width: "100%",
                    bottom: "11px",
                    padding: "0 13px 0 10px"
                }
            }
        }
    },
    MuiListItemAvatar: {
        styleOverrides: {
            root: {
                marginRight: "10px",
                minWidth: "24px"
            }
        }
    },
    MuiIconButton: {
        defaultProps: {
            disableRipple: true
        },
        styleOverrides: {
            root: {
                padding: 0
            }
        }
    },
    MuiSvgIcon: {
        styleOverrides: {
            root: {
                width: "auto"
            }
        }
    },
    MuiList: {
        defaultProps: {
            dense: true
        },
        styleOverrides: {
            root: {
                borderRadius: "4px 4px 0 0",
                backgroundColor: Colors.White
            }
        }
    },
    MuiMenuItem: {
        styleOverrides: {
            root: {
                padding: "4px auto 1px 12px"
            }
        }
    },
    MuiListItemIcon: {
        styleOverrides: {
            root: {
                color: Colors.Black
            }
        }
    },
    MuiListItemText: {
        defaultProps: {
            disableTypography: true
        }
    },
    MuiFormControlLabel: {
        styleOverrides: {
            root: {
                margin: 0
            },
            label: {
                color: Colors.DescriptionGray,
                fontSize: "10px",
                lineHeight: "16px"
            }
        }
    },
    MuiFormHelperText: {
        styleOverrides: {
            root: {
                fontSize: "10px",
                lineHeight: "16px"
            }
        }
    },
    MuiCheckbox: {
        styleOverrides: {
            root: {
                color: Colors.BackgroundInputWhite,
                padding: "8px",
                "&.Mui-checked": {
                    color: Colors.Primary,
                    padding: "8px"
                }
            }
        }
    },
    MuiButton: {
        defaultProps: {
            variant: "contained"
        },
        styleOverrides: {
            root: {
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
                boxShadow: "none",
                borderRadius: "3px",
                "&:hover": {
                    boxShadow: "none"
                }
            },
            outlined: {
                color: Colors.RecastBlack,
                backgroundColor: Colors.Transparent,
                border: "1px solid ".concat(Colors.GrayLight),
                "&:hover": {
                    backgroundColor: Colors.Transparent,
                    border: "1px solid ".concat(Colors.Primary)
                }
            },
            sizeSmall: {
                fontSize: "10px",
                lineHeight: undefined,
                fontWeight: 600,
                minWidth: "46px",
                "& .MuiButton-startIcon>*:nth-of-type(1)": {
                    fontSize: "8px"
                }
            }
        },
        variants: [
            {
                props: {
                    variant: "modal"
                },
                style: {
                    borderRadius: "18px",
                    color: Colors.DescriptionGray,
                    border: "1px solid ".concat(Colors.ModalButtonGray),
                    cursor: "pointer",
                    padding: "8px 26px",
                    background: "none",
                    fontSize: "11px",
                    fontWeight: 300,
                    "&:hover": {
                        background: Colors.ModalButtonHoverFill
                    },
                    ".light &": {
                        borderColor: Colors.ModalButtonGrayLight
                    }
                }
            },
            {
                props: {
                    variant: "socialLogin"
                },
                style: {
                    borderRadius: "4px",
                    color: Colors.RecastBlack,
                    border: "1px solid ".concat(Colors.Gray),
                    cursor: "pointer",
                    padding: "8px 14px",
                    background: "none",
                    fontSize: "12px",
                    fontWeight: 400,
                    "&:hover": {
                        background: Colors.ModalButtonHoverFill
                    }
                }
            }
        ]
    },
    MuiFormLabel: {
        styleOverrides: {
            root: {
                lineHeight: "14px",
                color: Colors.Black,
                "&.Mui-error": {
                    color: Colors.Black
                },
                "&.Mui-focused": {
                    color: Colors.Black
                }
            }
        }
    },
    MuiTextField: {
        defaultProps: {
            variant: "filled"
        }
    },
    MuiFilledInput: {
        styleOverrides: {
            root: {
                borderRadius: "2px",
                backgroundColor: Colors.BackgroundInputWhite,
                border: "1px solid ".concat(Colors.BackgroundInputWhite),
                "&.MuiInputBase-adornedEnd": {
                    backgroundColor: Colors.BackgroundInputWhite
                },
                "&.Mui-error": {
                    border: "1px solid ".concat(Colors.Error)
                },
                "&.Mui-readOnly": {
                    border: "1px solid ".concat(Colors.Primary)
                }
            }
        }
    },
    MuiTooltip: {
        styleOverrides: {
            tooltip: {
                backgroundColor: Colors.White,
                color: Colors.Black,
                fontSize: "14px",
                lineHeight: "18px",
                fontWeight: 200,
                padding: "16px",
                borderRadius: "4px"
            },
            popper: {
                filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.2))"
            }
        }
    },
    MuiLink: {
        styleOverrides: {
            root: {
                color: Colors.RecastBlack,
                textDecorationColor: Colors.RecastBlack,
                "&:hover": {
                    color: Colors.PrimaryDark
                },
                "&:visited": {
                    color: Colors.RecastBlack
                }
            }
        }
    },
    MuiRadio: {
        styleOverrides: {
            root: {
                color: Colors.Radio
            }
        }
    }
}; /* satisfies Components */ 
// TODO: We need proper palette handling to prevent repeating component colouring
var darkComponents = _object_spread_props$1(_object_spread$2({}, components), {
    MuiButton: {
        styleOverrides: {
            outlined: {
                color: Colors.White
            }
        }
    },
    MuiPaper: {
        styleOverrides: {
            root: {
                "&.MuiMenu-paper": {
                    border: "0px",
                    borderRadius: "0"
                },
                "& ul": {
                    padding: "0",
                    color: Colors.White,
                    backgroundColor: Colors.BackgroundInputDark,
                    border: "0px",
                    borderRadius: "0"
                },
                "& li": {
                    fontSize: "14px",
                    fontWeight: 400,
                    padding: "8px"
                }
            }
        }
    },
    MuiSelect: {
        styleOverrides: {
            root: {
                fontSize: "14px",
                fontWeight: 400,
                border: "0px",
                borderRadius: "2px",
                color: Colors.White,
                backgroundColor: Colors.BackgroundInputDark,
                "& .MuiSelect-icon": {
                    fill: Colors.White,
                    color: Colors.White
                },
                "& .MuiSelect-select": {
                    padding: "6px 8px"
                },
                "&.Mui-focused": {
                    backgroundColor: Colors.BackgroundInputDark
                },
                "&.MuiInputBase-root:hover": {
                    backgroundColor: Colors.GrayDark3
                }
            },
            icon: {
                right: "4px"
            }
        }
    },
    MuiFilledInput: {
        styleOverrides: {
            root: {
                fontSize: "12px",
                height: "32px",
                color: Colors.White,
                borderRadius: "2px",
                backgroundColor: Colors.BackgroundInputDark,
                border: "1px solid ".concat(Colors.BackgroundInputDark),
                "&.MuiInputBase-adornedStart": {
                    paddingLeft: "10px",
                    gap: "12px",
                    "& .MuiIcon-root": {
                        color: Colors.InputTextPlaceholderDark
                    }
                },
                "&.MuiInputBase-adornedEnd": {
                    backgroundColor: Colors.BackgroundInputDark
                },
                "&.Mui-error": {
                    border: "1px solid ".concat(Colors.Error)
                },
                "&.Mui-readOnly": {
                    border: "1px solid ".concat(Colors.Primary)
                },
                "& > .MuiInputBase-input": {
                    color: Colors.White,
                    "&::placeholder": {
                        opacity: 1,
                        color: Colors.InputTextPlaceholderDark
                    }
                }
            }
        }
    }
}); /*satisfies Components */ 
var breakpoints = {
    values: {
        xxs: 0,
        xs: 477,
        sm: 766,
        md: 990,
        lg: 1536,
        xl: 1920
    }
};
var darkTheme = createTheme({
    palette: darkPalette,
    components: darkComponents,
    typography: typography,
    breakpoints: breakpoints
});
var lightTheme = createTheme({
    palette: lightPalette,
    components: components,
    typography: typography,
    breakpoints: breakpoints
});
var testTheme = createTheme({
    breakpoints: breakpoints
});

function _array_like_to_array$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$3(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$3(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$1(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array$3(arr, i) {
    return _array_with_holes$3(arr) || _iterable_to_array_limit$3(arr, i) || _unsupported_iterable_to_array$3(arr, i) || _non_iterable_rest$3();
}
function _unsupported_iterable_to_array$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$3(o, minLen);
}
var MAX_WIDTH = 180;
var TicketContainer = styled(Box)({
    maxWidth: "".concat(MAX_WIDTH, "px"),
    padding: "1px",
    position: "relative",
    zIndex: 0
});
var TicketBackground = styled(Box, {
    shouldForwardProp: function(key) {
        return key !== "width";
    }
})(function(param) {
    var theme = param.theme, width = param.width;
    var insetHeight = 26 / MAX_WIDTH * width;
    return {
        position: "absolute",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        border: "1px solid ".concat(theme.palette.primary.main),
        clipPath: "polygon(0 0, 26% 0, 27% ".concat(insetHeight, "px, 73% ").concat(insetHeight, "px, 74% 0, 100% 0, 100% 100%, 0 100%)"),
        borderRadius: "3px",
        background: theme.palette.common.black,
        zIndex: -1
    };
});
var TicketContent = styled(Box)({
    width: "100%"
});
var CornerContainer = styled(Box)({
    flexGrow: 1,
    minWidth: "25%",
    maxWidth: "25%",
    borderRadius: "3px",
    zIndex: 1
});
var Inset = styled(ChannelPassEmptyInset)({
    transform: "translate(0, -1px)",
    strokeWidth: "1px",
    minWidth: "50%",
    maxWidth: "50%",
    color: "transparent"
});
function Ticket(_param) {
    var children = _param.children, topLeft = _param.topLeft, topRight = _param.topRight, props = _object_without_properties$1(_param, [
        "children",
        "topLeft",
        "topRight"
    ]);
    var _useState = _sliced_to_array$3(useState(MAX_WIDTH), 2), width = _useState[0], setWidth = _useState[1];
    var containerRef = useRef();
    useEffect(function() {
        var container = containerRef.current;
        if (!container) {
            return;
        }
        var resizeObserver = new ResizeObserver(function() {
            return setWidth(container.clientWidth);
        });
        resizeObserver.observe(container);
        return function() {
            return resizeObserver.disconnect();
        };
    }, []);
    return /*#__PURE__*/ jsxs(TicketContainer, _object_spread_props(_object_spread$1({}, props), {
        ref: containerRef,
        children: [
            /*#__PURE__*/ jsx(TicketBackground, {
                width: width
            }),
            /*#__PURE__*/ jsxs(TicketContent, {
                children: [
                    /*#__PURE__*/ jsxs(Stack, {
                        direction: "row",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ jsx(CornerContainer, {
                                children: topLeft
                            }),
                            /*#__PURE__*/ jsx(Inset, {
                                width: "50%",
                                height: undefined,
                                viewBox: "0 0 86 29",
                                sx: {
                                    strokeWidth: MAX_WIDTH / width
                                }
                            }),
                            /*#__PURE__*/ jsx(CornerContainer, {
                                children: topRight
                            })
                        ]
                    }),
                    children
                ]
            })
        ]
    }));
}

var Container = styled("div")({
    position: "relative",
    height: "32px",
    width: "25px",
    minWidth: "32px",
    minHeight: "25px",
    "&>svg": {
        fontSize: "32px"
    },
    "&>span": {
        position: "absolute",
        left: 0,
        right: 0,
        top: "10px",
        textAlign: "center",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: 1
    }
});
var Span = styled("span")({});
var TicketIconWithContent = function(param) {
    var children = param.children, ticketColor = param.ticketColor, textColor = param.textColor, sx = param.sx;
    return /*#__PURE__*/ jsxs(Container, {
        sx: sx,
        children: [
            /*#__PURE__*/ jsx(Icon, {
                component: Ticket$1,
                sx: {
                    color: ticketColor
                }
            }),
            /*#__PURE__*/ jsx(Span, {
                sx: {
                    color: textColor
                },
                children: children
            })
        ]
    });
};

function _array_like_to_array$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$2(arr, i) {
    return _array_with_holes$2(arr) || _iterable_to_array_limit$2(arr, i) || _unsupported_iterable_to_array$2(arr, i) || _non_iterable_rest$2();
}
function _unsupported_iterable_to_array$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$2(o, minLen);
}
var StyledDiv = styled("div")(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: theme.palette.primary.main,
        width: "auto",
        borderRadius: "2px",
        color: theme.palette.common.black,
        height: "32px",
        cursor: "pointer",
        userSelect: "none"
    };
});
var StyledMenu = styled(MenuList)({
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    borderRadius: "3px",
    padding: "7px 0"
});
var StyledMenuItem = styled(MenuItem)(function(param) {
    var theme = param.theme;
    return {
        padding: "0 0 0 7px",
        minHeight: "24px",
        color: theme.palette.common.black,
        "&:hover": {
            color: theme.palette.primary.main,
            backgroundColor: "transparent",
            "& .MuiTypography-root": {
                color: theme.palette.primary.main
            }
        }
    };
});
var renderOptions = function(options, handleTooltipClose) {
    return /*#__PURE__*/ jsx(StyledMenu, {
        children: options.map(function(param, i) {
            var onClick = param.onClick, text = param.text, icon = param.icon;
            return /*#__PURE__*/ jsxs(StyledMenuItem, {
                onClick: function() {
                    onClick();
                    handleTooltipClose();
                },
                disableRipple: true,
                disableTouchRipple: true,
                children: [
                    /*#__PURE__*/ jsx(Icon, {
                        sx: {
                            marginRight: "10px",
                            fontSize: "15px"
                        },
                        component: icon
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        sx: function(theme) {
                            return {
                                fontSize: "11px",
                                fontWeight: 400,
                                lineHeight: "16px",
                                color: theme.palette.common.black
                            };
                        },
                        children: text
                    })
                ]
            }, "option-".concat(i));
        })
    });
};
var TopupButton = function(param) {
    var options = param.options, currentBalance = param.currentBalance, onClick = param.onClick;
    var _useState = _sliced_to_array$2(useState(false), 2), isTooltipOpen = _useState[0], setIsTooltipOpen = _useState[1];
    var t = useTranslation().t;
    var handleTooltipClose = function() {
        return setIsTooltipOpen(false);
    };
    return /*#__PURE__*/ jsx(ClickAwayListener, {
        onClickAway: handleTooltipClose,
        children: /*#__PURE__*/ jsx("div", {
            children: /*#__PURE__*/ jsx(Tooltip$1, {
                componentsProps: {
                    tooltip: {
                        sx: {
                            background: "white",
                            padding: "0px",
                            maxWidth: "none"
                        }
                    },
                    arrow: {
                        sx: {
                            color: "white"
                        }
                    }
                },
                arrow: true,
                title: renderOptions(options, handleTooltipClose),
                PopperProps: {
                    disablePortal: true,
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [
                                    0,
                                    -11
                                ]
                            }
                        },
                        {
                            name: "sameWidth",
                            enabled: true,
                            fn: function(param) {
                                var state = param.state;
                                state.styles["popper"].width = "".concat(state.rects.reference.width, "px");
                            },
                            phase: "beforeWrite",
                            requires: [
                                "computeStyles"
                            ]
                        },
                        {
                            name: "arrow",
                            enabled: true,
                            fn: function(param) {
                                var state = param.state;
                                state.styles["arrow"].right = "0";
                                state.styles["arrow"].transform = "translate(-8px, 0)";
                            },
                            phase: "beforeWrite",
                            requires: [
                                "computeStyles"
                            ]
                        }
                    ]
                },
                open: isTooltipOpen,
                onClose: handleTooltipClose,
                enterDelay: 200,
                disableFocusListener: true,
                disableHoverListener: true,
                disableTouchListener: true,
                children: /*#__PURE__*/ jsxs(StyledDiv, {
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ jsx(Box, {
                            sx: function(theme) {
                                return {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "32px",
                                    width: "32px",
                                    backgroundColor: theme.palette.common.white,
                                    marginRight: "7px",
                                    borderRadius: "2px 0 0 2px"
                                };
                            },
                            children: /*#__PURE__*/ jsx(Icon, {
                                sx: function(theme) {
                                    return {
                                        height: "18px",
                                        width: "18px",
                                        margin: "7px",
                                        color: theme.palette.primary.main
                                    };
                                },
                                component: RecastR
                            })
                        }),
                        /*#__PURE__*/ jsxs(Box, {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                marginRight: "22px"
                            },
                            children: [
                                /*#__PURE__*/ jsx(Box, {
                                    sx: function(theme) {
                                        return {
                                            color: theme.palette.common.black,
                                            fontWeight: 400,
                                            fontSize: "6px",
                                            lineHeight: "9px"
                                        };
                                    },
                                    children: t("components.topup.balance", "BALANCE")
                                }),
                                /*#__PURE__*/ jsxs(Box, {
                                    sx: function(theme) {
                                        return {
                                            color: theme.palette.common.black,
                                            fontSize: "16px",
                                            fontWeight: 500,
                                            display: "flex",
                                            alignItems: "center"
                                        };
                                    },
                                    children: [
                                        currentBalance,
                                        /*#__PURE__*/ jsx(Icon, {
                                            sx: {
                                                height: "10px",
                                                width: "10px",
                                                marginLeft: "1px"
                                            },
                                            component: CastCredit
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            sx: function(theme) {
                                return {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "32px",
                                    width: "32px",
                                    borderRadius: "0 2px 2px 0",
                                    borderLeft: "1px solid ".concat(theme.palette.common.white)
                                };
                            },
                            onClick: function(e) {
                                e.stopPropagation();
                                setIsTooltipOpen(!isTooltipOpen);
                            },
                            children: /*#__PURE__*/ jsx(Icon, {
                                component: ThreeDotsVertical,
                                sx: function(theme) {
                                    return {
                                        height: "10px",
                                        color: theme.palette.common.white
                                    };
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
};

var volumeBarsAnimation = {
    v: "4.8.0",
    meta: {
        g: "LottieFiles AE 1.0.0",
        a: "",
        k: "",
        d: "",
        tc: ""
    },
    fr: 30,
    ip: 0,
    op: 197,
    w: 28,
    h: 28,
    nm: "volume-bars",
    ddd: 0,
    assets: [],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "Shape Layer 3",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        23.031,
                        24.984,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        -9.344,
                        9.359,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 0,
                            s: [
                                100,
                                64.505,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 13,
                            s: [
                                100,
                                76.337,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 26,
                            s: [
                                100,
                                64.505,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                y: [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 38,
                            s: [
                                100,
                                117.292,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                y: [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            t: 48,
                            s: [
                                100,
                                112.287,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                y: [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 63,
                            s: [
                                100,
                                117.292,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                y: [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            t: 76,
                            s: [
                                100,
                                112.287,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 98,
                            s: [
                                100,
                                114.562,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 113,
                            s: [
                                100,
                                91.354,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 123,
                            s: [
                                100,
                                104.096,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 135,
                            s: [
                                100,
                                56.054,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 147,
                            s: [
                                100,
                                76.337,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 159,
                            s: [
                                100,
                                114.562,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 171,
                            s: [
                                100,
                                91.354,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 181,
                            s: [
                                100,
                                104.096,
                                100
                            ]
                        },
                        {
                            t: 193,
                            s: [
                                100,
                                56.054,
                                100
                            ]
                        }
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            4.625
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            -4.625
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -9.375,
                                            9.375
                                        ],
                                        [
                                            -9.375,
                                            -4.375
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "st",
                            c: {
                                a: 0,
                                k: [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                ix: 3
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 6,
                                ix: 5
                            },
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: "Stroke 1",
                            mn: "ADBE Vector Graphic - Stroke",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 0,
            op: 780,
            st: 0,
            bm: 0
        },
        {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: "Shape Layer 2",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        14.031,
                        24.984,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        -9.344,
                        9.359,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 0,
                            s: [
                                100,
                                64.505,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 10,
                            s: [
                                100,
                                117.292,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                y: [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 20,
                            s: [
                                100,
                                64.505,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                y: [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            t: 42,
                            s: [
                                100,
                                112.287,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 55,
                            s: [
                                100,
                                76.337,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 74,
                            s: [
                                100,
                                114.562,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 86,
                            s: [
                                100,
                                91.354,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 96,
                            s: [
                                100,
                                104.096,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 108,
                            s: [
                                100,
                                56.054,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                y: [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 124,
                            s: [
                                100,
                                117.292,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                y: [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            t: 137,
                            s: [
                                100,
                                112.287,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 150,
                            s: [
                                100,
                                76.337,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 162,
                            s: [
                                100,
                                114.562,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 174,
                            s: [
                                100,
                                91.354,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 184,
                            s: [
                                100,
                                104.096,
                                100
                            ]
                        },
                        {
                            t: 196,
                            s: [
                                100,
                                56.054,
                                100
                            ]
                        }
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            4.625
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            -4.625
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -9.375,
                                            9.375
                                        ],
                                        [
                                            -9.375,
                                            -4.375
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "st",
                            c: {
                                a: 0,
                                k: [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                ix: 3
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 6,
                                ix: 5
                            },
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: "Stroke 1",
                            mn: "ADBE Vector Graphic - Stroke",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 0,
            op: 780,
            st: 0,
            bm: 0
        },
        {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "Shape Layer 1",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        5.031,
                        24.984,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        -9.344,
                        9.359,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                y: [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 0,
                            s: [
                                100,
                                64.505,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                y: [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            t: 22,
                            s: [
                                100,
                                112.287,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 35,
                            s: [
                                100,
                                76.337,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 54,
                            s: [
                                100,
                                114.562,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 66,
                            s: [
                                100,
                                91.354,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 76,
                            s: [
                                100,
                                104.096,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 88,
                            s: [
                                100,
                                56.054,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 104,
                            s: [
                                100,
                                117.292,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.667,
                                    0.667,
                                    0.667
                                ],
                                y: [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 114,
                            s: [
                                100,
                                64.505,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                y: [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            t: 136,
                            s: [
                                100,
                                112.287,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 149,
                            s: [
                                100,
                                76.337,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 168,
                            s: [
                                100,
                                114.562,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 180,
                            s: [
                                100,
                                91.354,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 190,
                            s: [
                                100,
                                104.096,
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                y: [
                                    1,
                                    0.833,
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333,
                                    0.333,
                                    0.333
                                ],
                                y: [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            t: 202,
                            s: [
                                100,
                                56.054,
                                100
                            ]
                        },
                        {
                            t: 218,
                            s: [
                                100,
                                117.292,
                                100
                            ]
                        }
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            4.625
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            -4.625
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -9.375,
                                            9.375
                                        ],
                                        [
                                            -9.375,
                                            -4.375
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "st",
                            c: {
                                a: 0,
                                k: [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                ix: 3
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 6,
                                ix: 5
                            },
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: "Stroke 1",
                            mn: "ADBE Vector Graphic - Stroke",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 0,
            op: 780,
            st: 0,
            bm: 0
        }
    ],
    markers: []
};

var iconAnimation = function(param) {
    var isIcon = param.isIcon, isMuted = param.isMuted;
    return {
        transition: "opacity 400ms ease-in-out",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        height: "18px",
        width: "18px",
        margin: "auto",
        opacity: isIcon ? isMuted ? 1 : 0 : isMuted ? 0 : 1
    };
};
var StyledMuteIcon = styled(MuteIcon, {
    shouldForwardProp: function(prop) {
        return prop !== "isMuted" && prop !== "isIcon";
    }
})(iconAnimation);
var StyledBox$1 = styled(Box$1, {
    shouldForwardProp: function(prop) {
        return prop !== "isMuted" && prop !== "isIcon";
    }
})(iconAnimation);
var StyledButton$2 = styled("button")(function(param) {
    var theme = param.theme, isMuted = param.isMuted;
    return {
        zIndex: 5,
        cursor: "pointer",
        position: "relative",
        width: 30,
        height: 30,
        border: 0,
        borderRadius: "50%",
        opacity: 1,
        transition: "background-color 400ms ease-in-out",
        backgroundColor: isMuted ? theme.palette.primary.main : theme.palette.grey[700],
        animation: "fadeIn 800mx 500ms ease-in-out forwards"
    };
});
/**
 * Themed, animated mute button.
 * Takes `sx` props to customise, `isMuted` to determine state and an `onClick`
 * to pass click events back.
 */ var ToggleMuteButton = function(param) {
    var isMuted = param.isMuted, onClick = param.onClick, sx = param.sx;
    return /*#__PURE__*/ jsxs(StyledButton$2, {
        isMuted: isMuted,
        sx: sx,
        onClick: onClick,
        type: "button",
        children: [
            /*#__PURE__*/ jsx(StyledMuteIcon, {
                isIcon: true,
                isMuted: isMuted,
                "aria-label": "mute sound"
            }),
            /*#__PURE__*/ jsx(StyledBox$1, {
                isIcon: false,
                isMuted: isMuted,
                children: /*#__PURE__*/ jsx(LottieAnimation, {
                    animationData: volumeBarsAnimation,
                    autoplay: true,
                    loop: true
                })
            })
        ]
    });
};

function _array_like_to_array$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$1(arr, i) {
    return _array_with_holes$1(arr) || _iterable_to_array_limit$1(arr, i) || _unsupported_iterable_to_array$1(arr, i) || _non_iterable_rest$1();
}
function _unsupported_iterable_to_array$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$1(o, minLen);
}
var ViewportContext = /*#__PURE__*/ createContext(null);
var ViewportProvider = function(props) {
    var children = props.children, widescreenBreakpoint = props.widescreenBreakpoint, debounceTimeMs = props.debounceTimeMs;
    var getViewportDataFromWindow = useCallback(function() {
        var width = window.innerWidth;
        var height = window.innerHeight;
        var isWidescreen = width > widescreenBreakpoint;
        var orientation = width > height ? "landscape" : "portrait";
        return {
            isWidescreen: isWidescreen,
            orientation: orientation,
            width: width,
            height: height
        };
    }, [
        widescreenBreakpoint
    ]);
    var _useState = _sliced_to_array$1(useState(function() {
        return getViewportDataFromWindow();
    }), 2), viewportData = _useState[0], setViewportData = _useState[1];
    useEffect(function() {
        var onResize = function() {
            setViewportData(getViewportDataFromWindow());
        };
        var debouncedResizeHandler = debounce(onResize, debounceTimeMs);
        window.addEventListener("resize", debouncedResizeHandler);
        return function() {
            debouncedResizeHandler.cancel();
            window.removeEventListener("resize", debouncedResizeHandler);
        };
    }, [
        debounceTimeMs,
        getViewportDataFromWindow
    ]);
    return /*#__PURE__*/ jsx(ViewportContext.Provider, {
        value: viewportData,
        children: children
    });
};
var useViewportContext = function() {
    var ctx = useContext(ViewportContext);
    if (ctx === null) {
        throw Error("ViewportContext was used before it was initialised");
    }
    return ctx;
};

function WidgetSection(param) {
    var title = param.title, subtitle = param.subtitle, children = param.children;
    return /*#__PURE__*/ jsxs(Stack, {
        gap: "24px",
        children: [
            /*#__PURE__*/ jsxs(Stack, {
                gap: "4px",
                padding: "0 8px",
                children: [
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "body2",
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Box, {
                children: children
            })
        ]
    });
}

var StyledButton$1 = styled("button")(function(param) {
    var theme = param.theme;
    return {
        cursor: "pointer",
        zIndex: 4,
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        border: 0,
        outline: 0,
        color: theme.palette.common.white,
        backgroundColor: "rgba(26, 26, 26, 0.75)",
        transition: "all 300ms ease-in-out",
        ".MuiSvgIcon-root": {
            transition: "all 300ms ease-in-out",
            color: "#666666"
        },
        "&:hover": {
            ".MuiSvgIcon-root": {
                color: theme.palette.common.white
            }
        }
    };
});
var SwipeScrollButton = function(param) {
    var isBackButton = param.isBackButton, isDisabled = param.isDisabled, onClick = param.onClick;
    return /*#__PURE__*/ jsx(StyledButton$1, {
        sx: {
            left: isBackButton ? 0 : "auto",
            right: isBackButton ? "auto" : 0,
            pointerEvents: isDisabled ? "none" : "initial",
            opacity: isDisabled ? 0 : 100
        },
        onClick: onClick,
        type: "button",
        children: isBackButton ? /*#__PURE__*/ jsx(ArrowBack, {}) : /*#__PURE__*/ jsx(ArrowForward, {})
    });
};

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var StyledBox = styled(Box)({
    position: "relative",
    display: "flex",
    alignItems: "flex-start",
    userSelect: "none",
    minHeight: "min-content"
});
var Content = styled(Box)({
    flex: 1,
    display: "flex",
    overflowX: "scroll",
    overflowY: "hidden",
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
        display: "none"
    }
});
var SwipeScroll = function(param) {
    var children = param.children, isScrollingWithButtons = param.isScrollingWithButtons, buttonScrollAmountPx = param.buttonScrollAmountPx, onSetScrollLeft = param.onSetScrollLeft, _param_useMouseWheel = param.useMouseWheel, useMouseWheel = _param_useMouseWheel === void 0 ? false : _param_useMouseWheel, _param_momentumVelocity = param.momentumVelocity, momentumVelocity = _param_momentumVelocity === void 0 ? 0.9 : _param_momentumVelocity, _param_mouseMoveAmountBeforeScrollingPx = param.mouseMoveAmountBeforeScrollingPx, mouseMoveAmountBeforeScrollingPx = _param_mouseMoveAmountBeforeScrollingPx === void 0 ? 10 : _param_mouseMoveAmountBeforeScrollingPx, _param_swipeEventThrottleMs = param.swipeEventThrottleMs, swipeEventThrottleMs = _param_swipeEventThrottleMs === void 0 ? 10 : _param_swipeEventThrottleMs, _param_scrollCallbackThrottleMs = param.scrollCallbackThrottleMs, scrollCallbackThrottleMs = _param_scrollCallbackThrottleMs === void 0 ? 100 : _param_scrollCallbackThrottleMs, _param_resizeDebounceMs = param.resizeDebounceMs, resizeDebounceMs = _param_resizeDebounceMs === void 0 ? 1000 : _param_resizeDebounceMs, _param_gap = param.gap, gap = _param_gap === void 0 ? 16 : _param_gap;
    var contentRef = useRef(null);
    var boxRef = useRef(null);
    var isDown = useRef(false);
    var startX = useRef(0);
    var velX = useRef(0);
    var scrollLeft = useRef(0);
    var momentumId = useRef();
    var initialMouseX = useRef(0);
    var initialMouseY = useRef(0);
    var _useState = _sliced_to_array(useState(false), 2), isSwiping = _useState[0], setIsSwiping = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isOverflow = _useState1[0], setIsOverflow = _useState1[1];
    var _useState2 = _sliced_to_array(useState(true), 2), isAtInitialScrollPosition = _useState2[0], setIsAtInitialScrollPosition = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), isAtEndScrollPosition = _useState3[0], setIsAtEndScrollPosition = _useState3[1];
    var cancelMomentumTracking = function() {
        momentumId.current && cancelAnimationFrame(momentumId.current);
    };
    var hasMouseMovedPastThreshold = useMemo(function() {
        return function(mouseX, mouseY) {
            return Math.abs(mouseX - initialMouseX.current) > mouseMoveAmountBeforeScrollingPx || Math.abs(mouseY - initialMouseY.current) > mouseMoveAmountBeforeScrollingPx;
        };
    }, [
        mouseMoveAmountBeforeScrollingPx
    ]);
    var throttledMouseMoveHandler = useMemo(function() {
        var handleMouseMove = function(event) {
            if (isDown.current && contentRef.current && !isScrollingWithButtons) {
                event.preventDefault();
                var x = event.pageX - contentRef.current.offsetLeft;
                var walk = x - startX.current;
                var prevScrollLeft = contentRef.current.scrollLeft;
                contentRef.current.scrollLeft = scrollLeft.current - walk;
                velX.current = contentRef.current.scrollLeft - prevScrollLeft;
                if (hasMouseMovedPastThreshold(event.clientX, event.clientY)) {
                    setIsSwiping(true);
                }
            }
        };
        return throttle(handleMouseMove, swipeEventThrottleMs);
    }, [
        isScrollingWithButtons,
        hasMouseMovedPastThreshold,
        swipeEventThrottleMs
    ]);
    var throttledWheelHandler = useMemo(function() {
        var handleMouseWheel = function(event) {
            if (contentRef.current && !isScrollingWithButtons) {
                cancelMomentumTracking();
                contentRef.current.scrollLeft += event.deltaY;
            }
        };
        return throttle(handleMouseWheel, swipeEventThrottleMs);
    }, [
        isScrollingWithButtons,
        swipeEventThrottleMs
    ]);
    var throttledScrollHandler = useMemo(function() {
        var handleScroll = function() {
            var checkForScrollBoundaries = function() {
                if (!contentRef.current || !boxRef.current || !buttonScrollAmountPx) {
                    return;
                }
                var scrollLeft = Math.round(contentRef.current.scrollLeft);
                var contentWidth = Math.round(contentRef.current.getBoundingClientRect().width);
                var totalScrollArea = Math.round(boxRef.current.scrollWidth);
                setIsAtInitialScrollPosition(scrollLeft === 0);
                setIsAtEndScrollPosition(scrollLeft + contentWidth >= totalScrollArea);
            };
            if (contentRef.current) {
                onSetScrollLeft === null || onSetScrollLeft === void 0 ? void 0 : onSetScrollLeft(contentRef.current.scrollLeft);
                checkForScrollBoundaries();
            }
        };
        return throttle(handleScroll, scrollCallbackThrottleMs);
    }, [
        onSetScrollLeft,
        buttonScrollAmountPx,
        scrollCallbackThrottleMs
    ]);
    var debounce = useDebounced(function() {
        var element = contentRef.current;
        if (element) {
            var clientWidth = element.clientWidth, scrollWidth = element.scrollWidth;
            setIsOverflow(clientWidth < scrollWidth);
        }
    }, resizeDebounceMs);
    useResizeObserver(contentRef, debounce);
    useResizeObserver(boxRef, debounce);
    var onBackButtonClick = function() {
        if (contentRef.current) {
            contentRef.current.scrollTo({
                left: contentRef.current.scrollLeft - (buttonScrollAmountPx !== null && buttonScrollAmountPx !== void 0 ? buttonScrollAmountPx : 0),
                behavior: "smooth"
            });
        }
    };
    var onForwardButtonClick = function() {
        if (contentRef.current) {
            contentRef.current.scrollTo({
                left: contentRef.current.scrollLeft + (buttonScrollAmountPx !== null && buttonScrollAmountPx !== void 0 ? buttonScrollAmountPx : 0),
                behavior: "smooth"
            });
        }
    };
    useEffect(function() {
        var element = contentRef.current;
        var handleMouseDown = function(event) {
            if (contentRef.current && !isScrollingWithButtons) {
                isDown.current = true;
                startX.current = event.pageX - contentRef.current.offsetLeft;
                scrollLeft.current = contentRef.current.scrollLeft;
                initialMouseX.current = event.clientX;
                initialMouseY.current = event.clientY;
                cancelMomentumTracking();
            }
        };
        var momentumLoop = function() {
            if (contentRef.current) {
                contentRef.current.scrollLeft += velX.current;
                velX.current = velX.current * momentumVelocity;
                if (Math.abs(velX.current) > 0.5) {
                    momentumId.current = requestAnimationFrame(function() {
                        return momentumLoop();
                    });
                }
            }
        };
        var handleMouseUp = function() {
            if (contentRef.current && !isScrollingWithButtons) {
                isDown.current = false;
                cancelMomentumTracking();
                momentumId.current = requestAnimationFrame(function() {
                    return momentumLoop();
                });
                setIsSwiping(false);
            }
        };
        var handleMouseLeave = function() {
            if (contentRef.current && !isScrollingWithButtons) {
                isDown.current = false;
                setIsSwiping(false);
            }
        };
        if (element) {
            element.addEventListener("mousedown", handleMouseDown);
            element.addEventListener("mouseup", handleMouseUp);
            element.addEventListener("mouseleave", handleMouseLeave);
            element.addEventListener("mousemove", throttledMouseMoveHandler);
            useMouseWheel && element.addEventListener("wheel", throttledWheelHandler, {
                passive: true
            });
            element.addEventListener("scroll", throttledScrollHandler);
        }
        return function() {
            if (element) {
                element.removeEventListener("mousedown", handleMouseDown);
                element.removeEventListener("mouseup", handleMouseUp);
                element.removeEventListener("mouseleave", handleMouseLeave);
                element.removeEventListener("mousemove", function() {
                    return throttledMouseMoveHandler;
                });
                useMouseWheel && element.removeEventListener("wheel", throttledWheelHandler);
                element.removeEventListener("scroll", throttledScrollHandler);
                throttledMouseMoveHandler.cancel();
                throttledWheelHandler.cancel();
                throttledScrollHandler.cancel();
            }
        };
    }, [
        isScrollingWithButtons,
        momentumVelocity,
        throttledMouseMoveHandler,
        useMouseWheel,
        throttledWheelHandler,
        throttledScrollHandler
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        sx: {
            position: "relative"
        },
        children: [
            isScrollingWithButtons && /*#__PURE__*/ jsx(SwipeScrollButton, {
                isDisabled: isAtInitialScrollPosition,
                isBackButton: true,
                onClick: onBackButtonClick
            }),
            /*#__PURE__*/ jsx(Content, {
                ref: contentRef,
                sx: {
                    cursor: isOverflow ? "grab" : "initial",
                    "& *": {
                        cursor: isOverflow && isSwiping ? "grabbing" : "initial"
                    }
                },
                children: /*#__PURE__*/ jsx(StyledBox, {
                    sx: {
                        columnGap: "".concat(gap, "px"),
                        "& *": {
                            pointerEvents: isOverflow && isSwiping ? "none" : "initial"
                        }
                    },
                    ref: boxRef,
                    children: children
                })
            }),
            isScrollingWithButtons && /*#__PURE__*/ jsx(SwipeScrollButton, {
                isDisabled: isAtEndScrollPosition,
                onClick: onForwardButtonClick
            })
        ]
    });
};

var TextContainer = styled(Box)({
    gap: "4px",
    paddingLeft: "8px",
    margin: "4px 0 24px 0"
});
var Grid = function(param) {
    var title = param.title, subtitle = param.subtitle, _param_rows = param.rows, rows = _param_rows === void 0 ? 1 : _param_rows, children = param.children;
    return /*#__PURE__*/ jsxs(Box, {
        sx: {
            marginBottom: "64px"
        },
        children: [
            /*#__PURE__*/ jsxs(TextContainer, {
                children: [
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        children: subtitle
                    })
                ]
            }),
            rows && /*#__PURE__*/ jsx(SwipeScroll, {
                momentumVelocity: 0,
                children: children
            })
        ]
    });
};

var Spinner = styled$1(CircularProgress)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.common.black
    };
});
function ModalLoader() {
    return /*#__PURE__*/ jsx(Stack, {
        direction: "row",
        gap: "8px",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "200px",
        children: /*#__PURE__*/ jsx(Spinner, {
            size: 32,
            thickness: 6
        })
    });
}

var StyledButton = styled(Button$1)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "9px",
        fontWeight: "300",
        height: "24px",
        color: "#FAFAFA",
        padding: "5px",
        borderRadius: "2px",
        backgroundColor: theme.palette.common.black,
        ":hover": {
            backgroundColor: "#363F3D"
        },
        "&.MuiButtonBase-root": {
            ".MuiButton-startIcon": {
                height: "14px",
                width: "14px",
                margin: "0 7px 0 0",
                svg: {
                    fontSize: "14px"
                }
            }
        }
    };
});
var IconButton = function(param) {
    var icon = param.icon, text = param.text, onClick = param.onClick, _param_type = param.type, type = _param_type === void 0 ? "button" : _param_type;
    return /*#__PURE__*/ jsx(StyledButton, {
        type: type,
        startIcon: icon,
        onClick: onClick,
        children: text
    });
};

var StyledFormControlLabel = styled(FormControlLabel)(function(param) {
    var theme = param.theme;
    return {
        border: "1px solid ".concat(Colors.SocialButtonBorder),
        borderRadius: "2px",
        height: "56px",
        width: "368px",
        "& .MuiTypography-root": {
            fontSize: "12px",
            fontWeight: 300,
            color: theme.palette.common.black
        }
    };
});
var StyledRadio = styled(Radio$1)(function(param) {
    var theme = param.theme;
    return {
        padding: "17px 12px 15px 8px",
        "&.Mui-checked": {
            color: theme.palette.primary.main
        }
    };
});
var Radio = function(param) {
    var label = param.label, value = param.value;
    return /*#__PURE__*/ jsx(StyledFormControlLabel, {
        label: label,
        value: value,
        name: "reason",
        control: /*#__PURE__*/ jsx(StyledRadio, {})
    });
};

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function LoadingOverlay(_param) {
    var loading = _param.loading, props = _object_without_properties(_param, [
        "loading"
    ]);
    return /*#__PURE__*/ jsx(Backdrop, {
        sx: function(theme) {
            return {
                color: Colors.LoaderOverlayOpacity,
                zIndex: theme.zIndex.drawer + 1
            };
        },
        open: loading,
        children: /*#__PURE__*/ jsx(CircularProgress, _object_spread({}, props))
    });
}

export { Avatar, Button, ButtonFollow, CastAmount, CastCreditProgress, CastOdometer, CastValue, ChannelHeader, Checkbox, CodeBox, Colors, Comment, CommentInput, CommentOptions, Dialog, Drawer, ExternalLink, FieldPrompt, FormApiErrorText, FormDatePicker, FormInput, FormPasswordInput, FormSelect, FormikCastValue, FormikCheckbox, FormikFormApiErrorText, FormikFormCodeInput, FormikFormDatePicker, FormikFormInput, FormikFormPasswordInput, FormikFormSelect, FormikQuickCastSelect, Grid, IconButton, Iframe, Image, ImageLinkButton, ImageLinkButtonRow, InfoTooltip, InputBox, InternalLink, LinkButton, LiveEventEndedModal, LoadingButton, LoadingOverlay, LottieAnimation, Modal, ModalActions, ModalAlert, ModalButton, ModalContent, ModalHeader, ModalLoader, ModalTextBox, ModalUnsupportedRegion, ModalWrapper, NestedDrawer, NotificationModal, NumberInput, QuickCastButton, QuickCastSelect, Radio, RecastLogoSpinner, RecastWidgetBranding, ReplayIsProcessingModal, SetUsername, ShareAndEarnButton, SignupButton, Slider, SocialLoginButton, StyledButton$5 as StyledButton, SwipeScroll, TextAvatar, Ticket, TicketIconWithContent, ToggleMuteButton, TopupButton, UpDownButtons, ViewportProvider, WidgetSection, accountTheme, darkTheme, lightTheme, testTheme, typography, useViewportContext };
